import { TranslationLookup } from '../Translation'
/**
 * Prefix
 * TC: Title Case
 * SC: Sentence Case
 * UC: UpperCase
 * LC: LowerCase
 */
/**
 * Prefix
 * TC: Title Case
 * SC: Sentence Case
 * UC: UpperCase
 * LC: LowerCase
 */
/**
 * Prefix
 * TC: Title Case
 * SC: Sentence Case
 * UC: UpperCase
 * LC: LowerCase
 */
/**
 * Prefix
 * TC: Title Case
 * SC: Sentence Case
 * UC: UpperCase
 * LC: LowerCase
 */
/**
 * Prefix
 * TC: Title Case
 * SC: Sentence Case
 * UC: UpperCase
 * LC: LowerCase
 */
/**
 * Prefix
 * TC: Title Case
 * SC: Sentence Case
 * UC: UpperCase
 * LC: LowerCase
 */
/**
 * Prefix
 * TC: Title Case
 * SC: Sentence Case
 * UC: UpperCase
 * LC: LowerCase
 */
/**
 * Prefix
 * TC: Title Case
 * SC: Sentence Case
 * UC: UpperCase
 * LC: LowerCase
 */
/**
 * Prefix
 * TC: Title Case
 * SC: Sentence Case
 * UC: UpperCase
 * LC: LowerCase
 */
/**
 * Prefix
 * TC: Title Case
 * SC: Sentence Case
 * UC: UpperCase
 * LC: LowerCase
 */
/**
 * Prefix
 * TC: Title Case
 * SC: Sentence Case
 * UC: UpperCase
 * LC: LowerCase
 */
/**
 * Prefix
 * TC: Title Case
 * SC: Sentence Case
 * UC: UpperCase
 * LC: LowerCase
 */
/**
 * Prefix
 * TC: Title Case
 * SC: Sentence Case
 * UC: UpperCase
 * LC: LowerCase
 */
/**
 * Prefix
 * TC: Title Case
 * SC: Sentence Case
 * UC: UpperCase
 * LC: LowerCase
 */
/**
 * Prefix
 * TC: Title Case
 * SC: Sentence Case
 * UC: UpperCase
 * LC: LowerCase
 */
/**
 * Prefix
 * TC: Title Case
 * SC: Sentence Case
 * UC: UpperCase
 * LC: LowerCase
 */
/**
 * Prefix
 * TC: Title Case
 * SC: Sentence Case
 * UC: UpperCase
 * LC: LowerCase
 */
/**
 * Prefix
 * TC: Title Case
 * SC: Sentence Case
 * UC: UpperCase
 * LC: LowerCase
 */
/**
 * Prefix
 * TC: Title Case
 * SC: Sentence Case
 * UC: UpperCase
 * LC: LowerCase
 */
/**
 * Prefix
 * TC: Title Case
 * SC: Sentence Case
 * UC: UpperCase
 * LC: LowerCase
 */
/**
 * Prefix
 * TC: Title Case
 * SC: Sentence Case
 * UC: UpperCase
 * LC: LowerCase
 */
/**
 * Prefix
 * TC: Title Case
 * SC: Sentence Case
 * UC: UpperCase
 * LC: LowerCase
 */
/**
 * Prefix
 * TC: Title Case
 * SC: Sentence Case
 * UC: UpperCase
 * LC: LowerCase
 */
/**
 * Prefix
 * TC: Title Case
 * SC: Sentence Case
 * UC: UpperCase
 * LC: LowerCase
 */
/**
 * Prefix
 * TC: Title Case
 * SC: Sentence Case
 * UC: UpperCase
 * LC: LowerCase
 */
/**
 * Prefix
 * TC: Title Case
 * SC: Sentence Case
 * UC: UpperCase
 * LC: LowerCase
 */
/**
 * Prefix
 * TC: Title Case
 * SC: Sentence Case
 * UC: UpperCase
 * LC: LowerCase
 */
/**
 * Prefix
 * TC: Title Case
 * SC: Sentence Case
 * UC: UpperCase
 * LC: LowerCase
 */
/**
 * Prefix
 * TC: Title Case
 * SC: Sentence Case
 * UC: UpperCase
 * LC: LowerCase
 */
/**
 * Prefix
 * TC: Title Case
 * SC: Sentence Case
 * UC: UpperCase
 * LC: LowerCase
 */
/**
 * Prefix
 * TC: Title Case
 * SC: Sentence Case
 * UC: UpperCase
 * LC: LowerCase
 */
/**
 * Prefix
 * TC: Title Case
 * SC: Sentence Case
 * UC: UpperCase
 * LC: LowerCase
 */

/* eslint-disable @stylistic/max-len */

const translations: TranslationLookup = {
  // Data Cardinalities
  SC_N_ITEMS: `{count, plural, =0 {No items} =1 {1 item} other {# items}}`,
  SC_N_GROUPS: `{count, plural, =0 {No groups} =1 {1 group} other {# groups}}`,
  SC_N_COLLATERALS: `{count, plural, =0 {No collaterals} =1 {1 collateral} other {# collaterals}}`,
  SC_N_SECONDARY_COLLATERALS: `{count, plural, =0 {No secondary collaterals} =1 {1 collateral} other {# collaterals}}`,
  SC_N_COLLATERAL_BASKETS: `{count, plural, =0 {No collateral baskets} =1 {1 collateral basket} other {# collateral baskets}}`,
  SC_N_PRODUCT_SECTORS: `{count, plural, =0 {No product sectors} =1 {1 product sector} other {# product sectors}}`,
  SC_N_COLLECTIONS: `{count, plural, =0 {No collections} =1 {1 collection} other {# collections}}`,
  SC_N_COUNTERPARTIES: `{count, plural, =0 {No counterparties} =1 {1 counterparty} other {# counterparties}}`,
  SC_N_FUNDS: `{count, plural, =0 {No funds} =1 {1 fund} other {# funds}}`,
  SC_N_TRADING_ENTITIES: `{count, plural, =0 {No trading entities} =1 {1 trading entity} other {# trading entities}}`,
  SC_N_COUNTERPARTY_GROUPS: `{count, plural, =0 {No counterparty groups} =1 {1 counterparty group} other {# counterparty groups}}`,
  SC_N_MASTER_LEGAL_AGREEMENTS: `{count, plural, =0 {No master legal agreements} =1 {1 master legal agreement} other {# master legal agreements}}`,

  // General Application
  SC_APP_DESCRIPTION: 'Creating the leading marketplace for all repo needs',

  // About Dialog
  TC_ABOUT: 'About',
  TC_OVERVIEW: 'Overview',
  TC_DIAGNOSTICS: 'Diagnostics',
  TC_VERSION: 'Version',
  TC_OPEN_FIN_VERSION: 'OpenFin Version',
  TC_BUILD: 'Build',
  SC_DIAGNOSTICS_SENT: 'Diagnostics info sent',

  // Navigation sections
  TC_SECTION_STAGING: 'Staging',
  TC_SECTION_INITIATED: 'Initiated',
  TC_SECTION_INITIATED_GRID_VIEW: 'Grid View',
  TC_SECTION_INCOMING: 'Incoming',
  TC_SECTION_CURVES: 'Curves',
  TC_SECTION_TRADES: 'Trades',
  TC_SECTION_AXE_BOARD: 'Axe Board',
  TC_SECTION_AXE_BOARD_INITIATOR: 'Initiated',
  TC_SECTION_AXE_BOARD_RESPONDER: 'Incoming',
  TC_SECTION_COLLATERAL_BASKETS: 'Baskets',
  TC_SECTION_NEGOTIATION_HISTORY: 'Negotiation History',
  TC_SECTION_HISTORICAL: 'Historical',
  TC_SECTION_ADMIN: 'Admin',
  TC_SECTION_PRIME_BROKER_DEFAULTS: 'Prime Broker Defaults',
  TC_SECTION_TRADING_ENTITY_DEFAULTS: 'Trading Entity Defaults',
  TC_SECTION_TRADING_ENTITY_ALIASES: 'Trading Entity Aliases',
  TC_SECTION_SALES_COVERAGE: 'Sales Coverage',
  TC_SECTION_TRADING_LIMITS: 'Trading Limits',
  TC_SECTION_RESPONDER_SALES_COVERAGE: 'Sell Side Sales Coverage',
  TC_SECTION_HAIRCUT: 'Haircut Matrix',
  TC_SECTION_PLATFORM: 'Platform',
  TC_SECTION_PLATFORM_CLIENT_LOGSTREAMS: 'Client Log Streams',
  TC_SECTION_ORDER_RECORD_KEEPING: 'Reporting Triggers',
  TC_SECTION_ORGANISATIONS: 'Organisations',
  TC_SECTION_TRADING_ENTITIES: 'Trading Entities',
  TC_SECTION_CLEARING_HOUSES: 'Clearing Venues',
  TC_SECTION_USERS: 'Users',
  TC_SECTION_COLLATERALS: 'Collaterals',
  TC_SECTION_EU_MARKET: 'EU Market',
  TC_SECTION_US_MARKET: 'US Market',
  TC_SECTION_FAT_FINGER_LIMITS: 'Fat Finger Limits',
  TC_SECTION_HOLIDAYS: 'Holidays',
  TC_SECTION_INDICES: 'Indices',
  TC_SECTION_MID_POST_TRADE_EVENTS: 'Mid/Post Trade Events',
  TC_SECTION_OPEN_REPO: 'Open Repo',
  TC_SECTION_OPEN: 'Open',
  TC_SECTION_STRUCTURED: 'Structured',
  TC_SECTION_TRADING_CONTROL: 'Trade Control',
  TC_SECTION_TRADE_SPLITS: 'Trade Splits',
  TC_SECTION_PRODUCTS: 'Products',
  TC_SECTION_SECTORS: 'Sectors',
  TC_SECTION_SECTOR_MAPPING: 'Sector Mapping',
  TC_SECTION_HISTORY: 'History',
  TC_SECTION_FX_RATES: 'FX Rates',
  TC_SECTION_ROLLS: 'Rolls',
  TC_SECTION_COMPLIANCE: 'Compliance',
  TC_SECTION_COMPLIANCE_ISSUER_ORGANISATIONS: 'Issuer Organisations',

  // Suspensions
  TC_SUSPENSIONS: 'Suspensions',
  SC_MARKET_CLOSED: 'The {market, select, EUROPE {Europe} US {US} other {}} market has closed.',
  SC_MARKET_PRE_OPEN: 'The {market, select, EUROPE {Europe} US {US} other {}} market is pre open.',
  SC_PLATFORM_SUSPENDED: 'The {market, select, EUROPE {Europe} US {US} other {}} platform has been suspended from trading.',
  SC_ORGANISATION_SUSPENDED: 'Your organisation has been suspended from trading.',
  SC_USER_SUSPENDED: 'You have been suspended from trading.',

  // Spreadsheet Upload
  TC_UPLOAD_DEFAULT: 'Default',
  TC_UPLOAD_FILE: 'Upload File',
  TC_BROWSE_FILE: 'Browse',
  TC_CHANGE_FILE: 'Change File',
  SC_ORDER_PLACEHOLDER_NARRATIVE_1: 'Your staging area is empty',
  SC_ORDER_PLACEHOLDER_NARRATIVE_2:
    'To add many assets quickly, paste from clipboard, drag and drop a .xls, csv file here, or browse your desktop to upload a new file.  Alternatively use the manual upload to add them one by one.',
  SC_UPLOAD_DROPZONE_NARRATIVE: 'Paste from clipboard, drag and drop .xls, csv, or browse your computer to upload',
  SC_INCOMING_PLACEHOLDER_NARRATIVE:
    'To add many prices quickly, paste from clipboard, drag and drop a .xls file here or browse your desktop to upload a new file.',
  SC_INCOMING_DROPZONE_NARRATIVE: 'Paste from clipboard, drag and drop .xls, csv, or browse your computer to upload',
  SC_MTE_PLACEHOLDER_NARRATIVE:
    'To add many mid trade events quickly, paste from clipboard, drag and drop a .xls file here or browse your desktop to upload a new file.',
  SC_MTE_DROPZONE_NARRATIVE: 'Paste from clipboard, drag and drop .xls, csv, or browse your computer to upload',
  SC_MTE_UPLOAD_PRELOADING_TRADES: 'Searching for matching trades...',
  SC_COLLATERAL_DROPZONE_NARRATIVE: 'Drag and drop .xls, csv, or browse your computer to upload',
  SC_TRADING_ENTITY_DROPZONE_NARRATIVE: 'Drag and drop .xls, csv, or browse your computer to upload',
  SC_TRADING_ENTITY_PRODUCT_DROPZONE_NARRATIVE: 'Drag and drop .xls, csv, or browse your computer to upload',
  SC_TRADING_RELATIONSHIP_DROPZONE_NARRATIVE: 'Drag and drop .xls, csv, or browse your computer to upload',
  SC_UPLOAD_SPREADSHEET_MAPPING_DROPZONE_NARRATIVE: 'Drag and drop a mapping file or browse your computer to upload',
  SC_CLIPBOARD: 'Clipboard',
  TC_ADD_ASSETS: 'Add Assets',
  TC_ADD_AXES: 'Add Axes',
  TC_UPLOAD_PRICES: 'Upload Prices',
  TC_UPLOAD_MTE: 'Upload Mid Trade Events',
  TC_UPLOAD_COLLATERAL: 'Upload Collaterals',
  TC_UPLOAD_TRADING_ENTITY: 'Upload Trading Entities',
  TC_UPLOAD_TRADING_ENTITY_PRODUCT: 'Upload Trading Entity Products',
  TC_UPLOAD_TRADING_RELATIONSHIP: 'Upload Trading Relationships',
  TC_UPLOAD_SPREADSHEET_MAPPING: 'Upload Spreadsheet Mapping',
  TC_VALID_MTE: 'Valid ({count})',
  TC_VALID: 'Valid',
  TC_INVALID: 'Invalid',
  TC_INVALID_MTE: 'Invalid ({count})',
  SC_DOWNLOAD_TEMPLATE: 'Download a sample template',
  TC_DOWNLOAD_ORDER_TEMPLATE_FILENAME: 'BrokerTecQuoteTemplate.xlsx',
  TC_DOWNLOAD_AXE_TEMPLATE_FILENAME: 'BrokerTecQuoteAxeTemplate.xlsx',
  TC_DOWNLOAD_INCOMING_TEMPLATE_FILENAME: 'BrokerTecQuoteIncomingTemplate.xlsx',
  TC_DOWNLOAD_CURVE_TEMPLATE_FILENAME: 'BrokerTecQuoteCurveTemplate.xlsx',
  TC_DOWNLOAD_MTE_TEMPLATE_FILENAME: 'BrokerTecQuoteMidTradeEventTemplate.xlsx',
  TC_DOWNLOAD_MTE_RESPONSE_TEMPLATE_FILENAME: 'BrokerTecQuoteMidTradeResponseTemplate.xlsx',
  TC_DOWNLOAD_COLLATERAL_TEMPLATE_FILENAME: 'BrokerTecQuoteCollateralTemplate.xlsx',
  TC_DOWNLOAD_TRADING_ENTITY_TEMPLATE_FILENAME: 'BrokerTecQuoteTradingEntityTemplate.xlsx',
  TC_DOWNLOAD_TRADING_ENTITY_PRODUCT_TEMPLATE_FILENAME: 'BrokerTecQuoteTradingEntityProductTemplate.xlsx',
  TC_DOWNLOAD_TRADING_RELATIONSHIP_TEMPLATE_FILENAME: 'BrokerTecQuoteTradingRelationshipTemplate.xlsx',
  SC_REPLACE_EXISTING_BONDS: 'Replace all existing bonds for your firm with this upload?',
  SC_AXE_SPREADSHEET_SUCCESS: '{count, plural, =0 {No axes were} =1 {1 axe was} other {# axes were}} loaded successfully',
  SC_AXE_SPREADSHEET_ERROR:
    '{count, plural, =0 {No axes} =1 {1 axe} other {# axes}} contained {errorCount, plural, =0 {no errors} =1 {a single error} other {# separate errors}}',
  SC_ORDER_SPREADSHEET_SUCCESS: '{count, plural, =0 {No orders were} =1 {1 order was} other {# orders were}} loaded successfully',
  SC_ORDER_SPREADSHEET_ERROR:
    '{count, plural, =0 {No orders} =1 {1 order} other {# orders}} contained {errorCount, plural, =0 {no errors} =1 {a single error} other {# separate errors}}',
  SC_INCOMING_SPREADSHEET_SUCCESS: '{count, plural, =0 {No prices were} =1 {1 price was} other {# prices were}} parsed successfully',
  SC_INCOMING_SPREADSHEET_ERROR:
    '{count, plural, =0 {No prices} =1 {1 price} other {# prices}} contained {errorCount, plural, =0 {no errors} =1 {a single error} other {# separate errors}}',
  SC_MTE_SPREADSHEET_SUCCESS:
    '{count, plural, =0 {No mid trade events were} =1 {1 mid trade event was} other {# mid trade events were}} parsed successfully',
  SC_MTE_SPREADSHEET_ERROR:
    '{count, plural, =0 {No mid trade events} =1 {1 mid trade event} other {# mid trade events}} contained {errorCount, plural, =0 {no errors} =1 {a single error} other {# separate errors}}',
  SC_COLLATERAL_SPREADSHEET_SUCCESS:
    '{count, plural, =0 {No collaterals were} =1 {1 collateral was} other {# collaterals were}} parsed successfully',
  SC_COLLATERAL_SPREADSHEET_ERROR:
    '{count, plural, =0 {No collaterals} =1 {1 collateral} other {# collaterals}} contained {errorCount, plural, =0 {no errors} =1 {a single error} other {# separate errors}}',
  SC_TRADING_ENTITY_SPREADSHEET_SUCCESS:
    '{count, plural, =0 {No trading entities were} =1 {1 trading entity was} other {# trading entities were}} parsed successfully',
  SC_TRADING_ENTITY_SPREADSHEET_ERROR:
    '{count, plural, =0 {No trading entities} =1 {1 trading entity} other {# trading entities}} contained {errorCount, plural, =0 {no errors} =1 {a single error} other {# separate errors}}',
  SC_TRADING_ENTITY_PRODUCT_SPREADSHEET_SUCCESS:
    '{count, plural, =0 {No trading entity products were} =1 {1 trading entity product was} other {# trading entity products were}} parsed successfully',
  SC_TRADING_ENTITY_PRODUCT_SPREADSHEET_ERROR:
    '{count, plural, =0 {No trading entity products} =1 {1 trading entity product} other {# trading entity products}} contained {errorCount, plural, =0 {no errors} =1 {a single error} other {# separate errors}}',
  SC_TRADING_RELATIONSHIP_SPREADSHEET_SUCCESS:
    '{count, plural, =0 {No trading relationships were} =1 {1 trading relationship was} other {# trading relationships were}} parsed successfully',
  SC_TRADING_RELATIONSHIP_SPREADSHEET_ERROR:
    '{count, plural, =0 {No trading relationships} =1 {1 trading relationship} other {# trading relationships}} contained {errorCount, plural, =0 {no errors} =1 {a single error} other {# separate errors}}',
  SC_COLLATERAL_BASKET_ALLOCATION_SPREADSHEET_SUCCESS:
    '{count, plural, =0 {No allocations were} =1 {1 allocation was} other {# allocations were}} loaded successfully',
  SC_COLLATERAL_BASKET_ALLOCATION_SPREADSHEET_ERROR:
    '{count, plural, =0 {No allocations} =1 {1 allocation} other {# allocations}} contained {errorCount, plural, =0 {no errors} =1 {a single error} other {# separate errors}}',
  SC_UPLOAD_ERROR_NARRATIVE: 'Update the selected mapping configuration or create a new one.',
  SC_UPLOAD_ERROR_NARRATIVE_MAPPING: 'Some required data could not be mapped. Please map your data to the required fields.',
  SC_UPLOAD_ERROR_SPREADSHEET_MAPPING: 'The file is not in the correct format or cannot be uploaded. Please try another file',
  SC_UPLOAD_ERROR_NARRATIVE_MAPPING_NO_ITEMS: 'Spreadsheet was uploaded but no rows were found',
  SC_SAVED_MAPPINGS: 'Select a mapping',
  TC_COLUMN_MAPPINGS: 'Column Mappings',
  TC_PENDING_PRICE_UPLOADS: 'Pending Price Uploads',
  TC_PENDING_MID_TRADE_EVENTS: 'Pending Mid Trade Events',
  TC_PENDING_COLLATERALS: 'Pending Collaterals',
  TC_PENDING_TRADING_ENTITIES: 'Pending Trading Entities',
  TC_PENDING_TRADING_ENTITY_PRODUCTS: 'Pending Trading Entity Products',
  TC_PENDING_TRADING_RELATIONSHIPS: 'Pending Trading Relationships',
  SC_SYSTEM_MAPPING: 'Use system default mapping',
  SC_COLUMN_HEADING: 'Column heading',
  SC_AMOUNT_FORMAT: 'Amount format',
  SC_DATE_FORMAT: 'Date format',
  SC_RATE_FORMAT: 'Rate format',
  SC_REF_RATE_FORMAT: 'Reference rate format',
  TC_ORDER_FIELD: 'Order Field',
  TC_COLLATERAL_BASKET_ALLOCATION_FIELD: 'Collateral Basket Allocation Field',
  TC_INCOMING_FIELD: 'Incoming Field',
  TC_MID_TRADE_EVENTS_FIELD: 'Mid Trade Events Field',
  TC_COLLATERAL_FIELD: 'Collateral Field',
  TC_TRADING_ENTITY_FIELD: 'Trading Entity Field',
  TC_TRADING_ENTITY_PRODUCT_FIELD: 'Trading Entity Product Field',
  TC_TRADING_RELATIONSHIP_FIELD: 'Trading Relationship Field',
  TC_SPREADSHEET_COLUMN: 'Spreadsheet Column',
  TC_CREATE_MAPPING: 'New Spreadsheet Mapping',
  TC_UPDATE_MAPPING: 'Update Spreadsheet Mapping',
  SC_DISPLAY_NAME: 'Display name',
  TC_PROMPT_TITLE_DELETE_SPREADSHEET_MAPPING: 'Delete Spreadsheet Mapping',
  SC_PROMPT_MSG_DELETE_SPREADSHEET_MAPPING: 'Are you sure you want to delete spreadsheet mapping "{name}"?',
  SC_DERIVE_FROM_AMOUNTS: 'Derive from amounts',
  SC_POSITIVE_IS_BUY: 'Positive is Buy',
  SC_POSITIVE_IS_SELL: 'Positive is Sell',
  SC_ENUM_VALUE_PREFIX: 'Use this value for ',
  SC_EXCEL_DATE_COLUMN: 'Excel date column',
  TC_CLIPBOARD_ERROR_TITLE: 'Upload Error',
  SC_CLIPBOARD_ERROR_MESSAGE:
    'There was an error pasting the spreadsheet content. Please try copying the rows from the spreadsheet again or choose another file.',
  TC_UPLOAD_ERROR_TITLE: 'Upload Error',
  SC_UPLOAD_ERROR_MESSAGE: 'There was an error uploading this file [{message}]. Please try again or choose another file.',
  SC_UPLOAD_PRELOAD_FAILED: 'There was an error when searching for matching trades. Please check and try again.',
  SC_REPORT_MAPPING_REQUESTED: 'Mappings Report requested',
  SC_DUPLICATE_TRADE_ID: 'Duplicate trade ID',
  SC_MISSING_TRADE_ID: 'Missing trade ID',
  SC_INVALID_TRADE_ID: 'Invalid trade ID',
  SC_MISSING_ACTION_TYPE: 'Missing action type',
  SC_MISSING_RESPONSE_TYPE: 'Missing response type',
  SC_INVALID_SERVICING_TRADE_ID: 'No valid mid trade event exists for trade ID',
  SC_INVALID_SEND_ON_TERMINATE: 'Send not available for TERMINATION mid trade event',
  SC_DUPLICATE_RFQ_ID: 'Duplicate RFQ ID',
  SC_DUPLICATE_NEGOTIATION_ID: 'Duplicate Negotiation ID',
  SC_DUPLICATE_UPLOAD: 'Duplicate upload found',
  SC_MISSING_RFQ_AND_NEGOTIATION_ID: 'Missing RFQ and Negotiation ID',
  SC_MISSING_COLLECTION_ID: 'Missing Collection ID',
  SC_MISSING_TERM: 'Missing Term',
  SC_INVALID_RFQ_ID: 'Unable to find negotiations with RFQ ID [{rfqId}]',
  SC_INVALID_NEGOTIATION_ID: 'Unable to find negotiations with Negotiation ID [{negotiationId}]',
  SC_NEGOTIATION_ID_RFQ_ID_CLASH: 'Negotiation ID refers to the same Negotiation as RFQ ID',
  SC_MULTIPLE_MATCHES:
    'Found multiple negotiations with collectionId [{collectionId}] startDate [{startDate}] endDate [{endDate}] term [{term}]',
  SC_CUSTOM_TERM: 'Custom term {detail}',
  SC_MISSING_START_DATE: 'Missing Start Date',
  SC_MISSING_END_DATE: 'Missing End Date',
  SC_NO_MATCHES: 'No matching negotiations with collectionId [{collectionId}] startDate [{startDate}] endDate [{endDate}] term [{term}]',
  SC_MISSING_RATE: 'Missing rate',
  SC_VALUE_REQUIRED: 'A value is required',
  SC_INVALID_TRADING_ENTITY: 'Cannot find trading entity with short name [{shortName}] and organisation short code [{orgShortCode}]',
  SC_INVALID_PRODUCT_SECTOR: 'Cannot find product sector with product name [{productName}] and sector name [{sectorName}]',
  SC_DUPLICATE_TRADING_ENTITY_PRODUCT:
    'Organisation short code [{orgShortCode}], trading entity short name [{shortName}], product name [{productName}] and Sector [{sectorName}] trying to set the same product permission more than once',
  SC_INVALID_BUY_ORGANISATION: 'Organisation does not have buy side profile',
  SC_INVALID_SELL_ORGANISATION: 'Organisation does not have sell side profile',
  SC_DUPLICATE_TRADING_RELATIONSHIP:
    'Buy side organisation {buyOrganisation}, buy side trading entity {buyTradingEntity}, sell side organisation {sellOrganisation} and sell trading entity {sellTradingEntity} trying to set the same trading relationship more than once',
  SC_SAME_ORGANISATION_ERROR: 'Buy side organisation and sell side organisation cannot be the same',
  SC_MISSING_DEFAULT_AGREEMENT: 'Missing default agreement',
  SC_INVALID_DEFAULT_AGREEMENT: 'Default agreement is not one of the allowed master legal agreements',
  SC_INVALID_STOCK_BORROWING_LENDING_ID: 'Cannot add Rate to Negotiations with repo type SBL',
  SC_SETTLEMENT_TYPE_NOT_EDITABLE: 'Settlement type is not editable for this negotiation and will be skipped',
  SC_BUTTON_SET_AS_DEFAULT: 'Set as default',

  // Activity Monitor
  TC_ACTIVITY_MONITOR: 'Activity Monitor',
  SC_NO_ACTIVITIES: 'No activities',
  SC_ORDER_BY_TIME_REMAINING: 'Order by time remaining',
  SC_CLEARING_FAILED_TRADES: 'Clearing Failed trades - action needed',

  // Tickets
  SC_NEGOTIATION_NOT_EXIST: 'The negotiation does not exist',
  SC_DEAL_NOT_EXIST: 'The trade does not exist',
  SC_COMPETITORS: 'Competitors: ',
  TC_TICKET_QUICK_SUMMARY: 'Quick Summary',
  TC_TICKET_SWIFT_INTERACTIONS: 'SWIFT Interactions',
  TC_TICKET_AMOUNT: 'Amount',
  TC_TICKET_PRICING: 'Pricing',
  TC_TICKET_TERM: 'Term',
  TC_TICKET_TIMERS: 'Timers',
  TC_TICKET_INSTRUMENT: 'Instrument',
  TC_TICKET_PARTIES: 'Parties',
  TC_TICKET_FLAGS: 'Flags',
  TC_TICKET_AUDIT: 'Audit',
  TC_TICKET_INTERNAL_BOOKING: 'Internal Booking',
  TC_NOTIONAL_ORIGINAL: 'Original Notional{amountFormat, select, THOUSANDS { (K)} MILLIONS { (M)} other {}}',
  TC_NOTIONAL_ORIGINAL_SHORT: 'Original Notional',
  TC_START_CONSIDERATION_ORIGINAL: 'Start Consideration Original',
  TC_RATE_TARGET: 'Rate Target',
  TC_HAIRCUT_TARGET: 'Haircut Target',
  TC_START_DATE_TARGET: 'Start Date Target',
  TC_END_DATE_TARGET: 'End Date Target',
  TC_CONTACT: 'Contact',
  SC_ORIGINAL_RFQ_CANCELLED: 'Original RFQ cancelled',
  SC_ORIGINAL_RFQ_TIME_REMAINING: 'Original RFQ time remaining',
  SC_TICKET_MODIFIED_NARRATIVE: 'You have made amendments',
  SC_TICKET_LAST_LOOK_NARRATIVE: 'This quote is subject to a final acceptance',
  SC_TICKET_QUOTE_SUBJECT_NARRATIVE: 'The original OTW time has now expired',
  SC_TICKET_WITHDRAWN_ACTOR_NARRATIVE: 'You withdrew your quote',
  SC_TICKET_WITHDRAWN_RECEIVER_NARRATIVE: 'The quote has been withdrawn',
  SC_TICKET_CANCELLED_INITIATOR_NARRATIVE: 'You have cancelled this RFQ',
  SC_TICKET_CANCELLED_RESPONDER_NARRATIVE: 'This RFQ was cancelled by the initiator',
  SC_ORIGINAL_DEAL_CANCELLED: 'Original trade cancelled',
  SC_TICKET_CANCELLED_ADMIN_NARRATIVE: 'A BrokerTec Admin has cancelled this trade',
  SC_TICKET_CANCELED_BY_USER: 'This trade has been canceled by user: {userId}',

  // action/message types
  TC_ERROR: 'Error',
  TC_UNPREPARED: 'Unprepared',
  TC_READY: 'Ready',
  TC_READY_TO_SEND: 'Ready to Send',
  TC_DRAFT: 'Draft',
  TC_AWAITING_RESPONSE: 'Awaiting Response',
  TC_AWAITING: 'Awaiting',
  TC_NEW_REQUEST: '{type, select, NONE {New} ROLL {Roll} UNWIND {Unwind} SUB {Sub} other {}}',
  TC_PRICED: 'Priced',
  TC_PRICED_NEW: 'Priced (New)',
  TC_UNPRICED: 'Unpriced',
  TC_QUOTED: 'Quoted',
  TC_COUNTERED: 'Countered',
  TC_COUNTER_IN: 'Counter In',
  TC_REFRESHED: 'Refreshed',
  TC_QUOTE_SUBJECT: 'Quote Subject',
  TC_SENT: 'Sent',
  TC_SUBMITTED: 'Submitted',
  TC_ACCEPTED: 'Accepted',
  TC_PENDING: 'Pending',
  TC_PENDING_FAILED: 'Pending Failed',
  TC_PENDING_AWAITING_PRICE: 'Pending Awaiting Price',
  TC_REJECTED: 'Rejected',
  TC_WITHDRAWN: 'Withdrawn',
  TC_SUBJECT: 'Subject',
  TC_LAST_LOOK: 'Last Look',
  TC_CANCELLED: 'Cancelled',
  TC_EXPIRED: 'Expired',
  TC_TRADED_AWAY: 'Traded Away',
  TC_MISSED: 'Missed',
  TC_TOTAL: 'Total',
  TC_DONE: 'Done',
  TC_AMENDED: 'Amended',
  TC_AMENDING: 'Amending',
  TC_CANCELLING: 'Cancelling',
  TC_COMPLETED: 'Completed',
  TC_ONGOING: 'Ongoing',
  TC_ACTIVE: 'Active',
  TC_SUSPENDED: 'Suspended',
  TC_ENABLED: 'Enabled',
  TC_DISABLED: 'Disabled',
  TC_DELETED: 'Deleted',
  TC_PRE_OPEN: 'Pre Open',
  TC_OPEN: 'Open',
  TC_CLOSED: 'Closed',
  TC_CLEARING_FAILED: 'Clearing Failed',
  TC_CLEARING_PENDING: 'Clearing Pending',
  TC_CLEARING_REJECTED: 'Clearing Rejected',
  TC_CLEARING_REQUIRED: 'Clearing Required',
  TC_SPONSORED_SUFFIX: 'S',
  TC_UNASSIGNED: 'Unassigned',
  TC_ASSIGNED: 'Assigned',
  TC_UNALLOCATED: 'Unallocated',
  TC_ALLOCATED: 'Allocated',
  TC_EXPIRED_ALLOCATION: 'Expired Allocation',
  TC_SUBSTITUTION: 'Substitution',
  TC_SUBSTITUTION_PENDING: 'Pending',
  TC_RERATE: 'Re-Rate',
  TC_CLOSE_OPEN: 'Close/Open',
  TC_RETURN_RECALL: 'Return/Recall',
  TC_TERMINATION: 'Termination',
  TC_TERMINATE: 'Terminate',
  TC_ROLL_IN_PLACE: 'Roll In Place',
  TC_AMEND_TRADE: 'Amend Trade',
  TC_NEW_DEAL: 'New Deal',
  TC_CANCEL_TRADE: 'Cancel Trade',
  TC_COUNTERED_REFRESHED: 'Countered / Refreshed',
  TC_ALL: 'All',
  TC_NONE: 'None',
  TC_ROLLED: 'Rolled',

  // Hero panel labels
  TC_HERO_STAGING: 'Staging',
  TC_HERO_INITIATED: 'Initiated',
  TC_HERO_INCOMING: 'Incoming',
  TC_HERO_CURVES: 'Curves',
  TC_HERO_DEALS: 'Trades',
  TC_HERO_MID_POST_TRADE_EVENTS: 'Mid/Post Trade Events',
  TC_HERO_OPEN_REPO: 'Open Repo',
  TC_HERO_STRUCTURED: 'Structured',
  TC_HERO_COLLATERAL_BASKETS: 'Baskets',
  TC_HERO_NEGOTIATION_HISTORY: 'Negotiation History',
  TC_HERO_HISTORICAL: 'Historical',
  TC_HERO_PRIME_BROKER_DEFAULTS: 'Prime Broker Defaults',
  TC_HERO_TRADING_ENTITY_DEFAULTS: 'Trading Entity Defaults',
  TC_HERO_TRADING_ENTITY_ALIASES: 'Trading Entity Aliases',
  TC_HERO_SALES_COVERAGE: 'Sales Coverage',
  TC_HERO_TRADING_LIMITS: 'Trading Limits',
  TC_HERO_RESPONDER_SALES_COVERAGE: 'Sell Side Sales Coverage',
  TC_HERO_HAIRCUT: 'Haircut Matrix',
  TC_HERO_PLATFORM: 'Platform',
  TC_HERO_ORDER_RECORD_KEEPING: 'Reporting Triggers',
  TC_HERO_ORGANISATIONS: 'Organisations',
  TC_HERO_TRADING_ENTITIES: 'Trading Entities',
  TC_HERO_CLEARING_HOUSES: 'Clearing Venues',
  TC_HERO_USERS: 'Users',
  TC_HERO_COLLATERALS: 'Collaterals',
  TC_HERO_FAT_FINGER_LIMITS: 'Fat Finger Limits',
  TC_HERO_TRADING_CONTROL_LIMITS: 'Trading Control Limits',
  TC_HERO_HOLIDAYS: 'Holidays',
  TC_HERO_INDICES: 'Indices',
  TC_HERO_PRODUCTS: 'Products',
  TC_HERO_SECTORS: 'Sectors',
  TC_HERO_SECTOR_MAPPING: 'Sector Mapping',
  TC_HERO_SECTOR_DRAFT_MAPPING: 'Sector Draft Mapping',
  TC_HERO_FX_RATES: 'FX Rates',
  TC_HERO_SUMMARY: 'Summary',
  TC_HERO_STATUS: 'Status',
  TC_HERO_CASH_AMOUNTS: 'Cash Amounts',
  TC_HERO_ALL: 'All',
  TC_HERO_NOTIONAL: 'Notional',
  TC_DEALS: 'Trades',
  TC_NET_CASH: 'Net Cash',
  TC_TADJ_CASH: 'Tadj Cash',
  TC_HERO_ROLLS: 'Rolls',
  TC_HERO_INITIATED_AXE: 'Initiated - Axe',
  TC_HERO_INCOMING_AXE: 'Incoming - Axe',
  TC_HERO_ABSOLUTE: 'ABS',
  TC_HERO_NET: 'NET',
  TC_HERO_ISSUER_ORGANISATIONS: 'Issuer Organisations',

  // Send RFQ Panel
  TC_ASSETS: 'Assets',
  SC_ASSETS_OVERWRITE_WARNING_COUNT: '{assets, plural, =1 {1 asset } other {# assets }}',
  SC_ASSETS_OVERWRITE_WARNING_MESSAGE: '{assets, plural, =1 {has} other {have}} saved details that will be overwritten',
  SC_ASSETS_OVERWRITE_READONLY_WARNING_MESSAGE: '{assets, plural, =1 {has} other {have}} saved details that would be overwritten',
  TC_DETAILS: 'Details',
  TC_SEND_ALL: 'Send All',
  TC_PREPARE_RFQ: 'Prepare RFQs',
  TC_PREPARE_BASKET: 'Prepare Basket',
  TC_DURATION_HOURS_MINS: 'RFQ Time (hh:mm)',
  TC_CALLABLE_PERIOD: 'Callable Period (Days)',
  TC_SETTLEMENT: 'Settlement',
  SC_BILATERAL_SETTLEMENT: 'Bilateral',
  SC_DIRECT_CLEARING_SETTLEMENT: 'Direct clearing',
  SC_SPONSORED_CLEARING_SETTLEMENT: 'Sponsored clearing',
  SC_TRIPARTY_SETTLEMENT: 'Triparty',
  TC_CSD: 'CSD',
  TC_CCP: 'CCP',
  TC_SPONSOR: 'Sponsor',
  TC_SHOW_COMPETITION: 'Show Competition',
  SC_DURATION_HOURS: '{duration, plural, =1 {1 hour} other {# hours}}',
  SC_DURATION_MINUTES: '{duration, plural, =1 {1 min} other {# mins}}',
  SC_DETAILS_SUMMARY: '{mins, plural, =1 {1 min} other {# mins}}',
  TC_COUNTERPARTIES: 'Counterparties',
  TC_POSITIONS: 'Positions',
  TC_GROUPS: 'Groups',
  SC_SELECTED_COUNTERPARTIES_SIZE: '{size} selected',
  SC_COUNTERPARTIES_SUMMARY: '{size} selected',
  SC_SELECT_COUNTERPARTY: 'Select a counterparty',
  SC_REMOVE_COUNTERPARTIES: 'Remove all counterparties',
  SC_SELECT_TRADING_ENTITY: 'Select a trading entity',
  SC_REMOVE_TRADING_ENTITIES: 'Remove all trading entities',
  SC_POSITION_SUMMARY:
    '{axes, plural, =1 {1 axe} other {# axes}}; {rolls, plural, =1 {1 roll} other {# rolls}}; {unwinds, plural, =1 {1 unwind} other {# unwinds}}; {subs, plural, =1 {1 sub} other {# subs}}',
  SC_SELECT_A_GROUPING: 'Choose a grouping',
  SC_GROUP_BY_ASSETS: 'Group by assets',
  SC_GROUP_BY_COUNTERPARTIES: 'Group by counterparties',
  SC_MBS_COLLATERAL_ERROR_MESSAGE: `Ultimate parent issuer is not on a US recognised exchange and collateral is not registered as 144A, so cannot be sent to more than one counterparty`,
  SC_MISSING_GFID_ERROR_MESSAGE:
    'One or more counterparties do not have the correct GFID details. Please contact BTQ admin for more information or select another counterparty',

  // Axe
  TC_AXE_NEW: 'Add Axe',
  TC_AXE_STAGE: 'Stage',
  TC_AXE_SEND: 'Send',
  TC_AXE_CANCEL: 'Cancel',
  TC_AXE_CLONE: 'Clone',
  TC_AXE_STAGE_SELECT_FUND_COLLATERAL:
    'Select a fund{collateralEnabled, select, true { and collateral} false {} other {}} to stage {multiple, select, true {new orders}false {a new order} other {a new order}}',
  TC_AXE_STAGE_TITLE: 'Stage {multiple, select, false {a new order} true {multiple new orders} other {a new order}}',
  TC_AXE_ID: 'Axe ID',
  TC_EXTERNAL_AXE_ID: 'External Axe ID',
  TC_AXE_STAGE_NO_TRADING_ENTITIES: 'No trading entities that can trade all the selected axes',
  SC_AXE_ENTER_DETAILS: 'Enter axe details',
  SC_AXE_UPLOAD_TRADING_ENTITY_NOT_FOUND: 'Trading entity [{shortCode}] not found',

  // Login / logout
  TC_LOGIN_TITLE: 'Login',
  TC_LOGOUT_TITLE: 'Sign Out',
  SC_LOGOUT_PROMPT: 'This will end your current session. Are you sure you want to continue?',
  SC_CLOSECODE_SESSION_EXPIRED: 'Your session has expired',
  SC_CLOSECODE_USER_DISABLED: 'Your user has been disabled',

  // User Preferences
  TC_USER_PREFERENCE: 'User Preferences',
  TC_USER_PREFERENCE_GENERAL: 'General',
  TC_USER_PREFERENCE_NOTIFICATIONS: 'Openfin Notifications',
  TC_USER_PREFERENCE_BROWSER_NOTIFICATIONS: 'Browser Notifications',
  TC_USER_PREFERENCE_PREPARE: 'Prepare Panel',
  TC_USER_PREFERENCE_COUNTERPARTY_GROUPS: 'Counterparty Groups',
  TC_USER_PREFERENCE_NEGOTIATION: 'Negotiation',
  TC_USER_PREFERENCE_REGULATORY: 'Regulatory',
  SC_DIRECTION_FORMAT: 'Direction Format',
  SC_DEFAULT_MARKET: 'Default market',
  SC_DATE_FORMAT_DEFAULT: 'Default date format',
  SC_PRIMARY_IDENTIFIER: 'Primary identifier',
  SC_AMOUNT_FORMAT_DEFAULT: 'Default amount format',
  SC_INITIATED_GRID_VIEW: 'Initiated grid view',
  SC_BOOK_DEFAULT: 'Default book',
  SC_STRATEGY_DEFAULT: 'Default strategy',
  SC_CALLABLE_DEFAULT: 'Default callable',
  SC_CALLABLE_DAYS_DEFAULT: 'Default callable period days',
  SC_SETTLEMENT_DEFAULT: 'Set the default settlement to',
  SC_SHOW_COMPETITION_DEFAULT: 'Default show competition',
  SC_SHOW_TOAST_NOTIFICATIONS: 'Show toast notifications',
  SC_SHOW_BROWSER_NOTIFICATIONS: 'Show browser notifications',
  SC_PLAY_ALERT_ON_NOTIFICATION: 'Play audible alert on notification',
  SC_RFQ_DURATION_DEFAULT: 'Default RFQ time (hh:mm)',
  SC_RFQ_TYPE_DEFAULT: 'Default RFQ type',
  SC_GROUP_NAME: 'Group name',
  SC_MEMBERS: 'Members',
  SC_NO_COUNTERPARTY_GROUPS: 'No counterparty groups',
  SC_OTW_DURATION_DEFAULT: 'Default OTW time (hh:mm)',
  SC_DEFAULT_HAIRCUT_TYPE: 'Default Collateral/Haircut',
  SC_BUY_SELL: 'Buy / Sell',
  SC_RVP_RP: 'Rev Repo / Repo',
  SC_BID_OFFER: 'Bid / Offer',
  SC_BORROW_LEND: 'Borrow / Lend',
  SC_EU_DATE: 'EU (DD/MM/YYYY)',
  SC_US_DATE: 'US (MM/DD/YYYY)',
  SC_DD_MMM_YYYY: 'DD MMM YYYY',
  SC_ACTUAL: 'Actual',
  SC_THOUSANDS: 'Thousands',
  SC_MILLIONS: 'Millions',
  SC_DEFAULT_INVESTMENT_DECISION_MAKER: 'Default investment decision maker',
  SC_DEFAULT_EXECUTION_DECISION_MAKER: 'Default execution decision maker',
  TC_EU: 'EU',
  TC_US: 'US',
  TC_CUSTOM: 'Custom',
  SC_HAIRCUT_SIGN: 'Haircut sign',
  SC_BASKET_ALLOCATION_TIME: 'Default Basket Allocation Time',
  TC_COPY_PASTE_FORMAT: 'Copy/Paste Format',
  TC_TABULAR: 'Tabular',
  TC_PLAIN_TEXT: 'Plain Text',

  // Platform Admin
  TC_EU_MARKET: 'EU Market',
  TC_US_MARKET: 'US Market',
  TC_MARKET_TRADE_DATE_INFO: 'Market Trade Date: {tradeDate}',
  TC_PROMPT_TITLE_SUSPEND_PLATFORM_EU: 'Suspend Platform Trading - Europe',
  SC_PROMPT_MSG_SUSPEND_PLATFORM_EU: 'This will suspend trading for the ENTIRE EUROPE PLATFORM. Are you sure you want to continue?',
  TC_PROMPT_TITLE_ACTIVATE_PLATFORM_EU: 'Activate Platform Trading - Europe',
  SC_PROMPT_MSG_ACTIVATE_PLATFORM_EU: 'This will activate trading for the ENTIRE EUROPE PLATFORM. Are you sure you want to continue?',
  TC_PROMPT_TITLE_END_DAY_EU: 'End of Day - Europe',
  SC_PROMPT_MSG_END_DAY_EU:
    'You are about to stop trading on the Europe system. The system trade date will also be rolled to the next day - Are you sure you want to continue?',
  TC_PROMPT_TITLE_START_DAY_EU: 'Start of Day - Europe',
  TC_PROMPT_TITLE_START_DAY_EU_TOMORROW: 'Start of Day - Europe(T+1)',
  SC_PROMPT_MSG_START_DAY_EU: 'You are about to start trading on the Europe system - Are you sure you want to continue?',
  SC_PROMPT_MSG_START_DAY_EU_TOMORROW: 'You are about to start trading on the Europe system(T+1) - Are you sure you want to continue?',
  TC_PROMPT_TITLE_SUSPEND_PLATFORM_US: 'Suspend Platform Trading - US',
  SC_PROMPT_MSG_SUSPEND_PLATFORM_US: 'This will suspend trading for the ENTIRE US PLATFORM. Are you sure you want to continue?',
  TC_PROMPT_TITLE_ACTIVATE_PLATFORM_US: 'Activate Platform Trading - US',
  SC_PROMPT_MSG_ACTIVATE_PLATFORM_US: 'This will activate trading for the ENTIRE US PLATFORM. Are you sure you want to continue?',
  TC_PROMPT_TITLE_END_DAY_US: 'End of Day - US',
  SC_PROMPT_MSG_END_DAY_US:
    'You are about to stop trading on the US system. The system trade date will also be rolled to the next day - Are you sure you want to continue?',
  TC_PROMPT_TITLE_START_DAY_US: 'Start of Day - US',
  SC_PROMPT_MSG_START_DAY_US: 'You are about to start trading on the US system - Are you sure you want to continue?',
  TC_PROMPT_TITLE_PRE_START_DAY_US: 'Pre Open',
  SC_PROMPT_MSG_PRE_START_DAY_US: 'You are about to pre open the US system - Are you sure you want to continue?',
  SC_NARRATIVE_PLATFORM_WARNING: 'Warning: Changes made here will affect the ENTIRE PLATFORM',
  TC_PLATFORM_FEATURE: 'Platform Feature',
  TC_PLATFORM_FEATURE_TOGGLES: 'Platform Feature Toggles',
  TC_ALLOW_PARTIAL_FILLS: 'Allow Partial Fills',
  TC_FIX_TRADE_QUERIES: 'FIX Trade Queries',
  TC_FIX_FIELD_DISABLED: 'This field is not editable for FIX orders',
  TC_ENABLE_CURVE_COLLECTIONS: 'Enable Curve OCO Collections',
  TC_ENABLE_START_CONSIDERATION_OVERRIDE: 'Enable Start Consideration Override',
  TC_ENABLE_BATCHING: 'Enable Cluster Batching',
  TC_ENABLE_LIGHT_WEIGHT_PRICE: 'Enable Light Weight Price',
  TC_ENABLE_LIGHT_WEIGHT_PRICE_WEB: 'Enable Light Weight Price Web Gateways',
  TC_ENABLE_FIRDS: 'Enable Firds report scheduled generation and first trade date population',
  TC_ENABLE_CORPORATES: 'Enable Corporates',
  TC_ENABLE_EVERGREENS: 'Enable Evergreens',
  TC_ENABLE_MBS: 'Enable MBS',
  TC_ENABLE_SPREADSHEET_UNKNOWN_COLLATERAL: 'Enable spreadsheet upload with unknown collateral',
  TC_ENABLE_REAL_TIME_PURGE: 'Enable real time purge',
  TC_ENABLE_NEGOTIATION_INFLIGHT: 'Enable negotiation in flight',
  TC_ENABLE_FIX_PERCENTAGE_FORMAT: 'FIX Percentage Format',
  TC_PROMPT_TITLE_TOGGLE_ALLOW_PARTIAL: '{enabled, select, true {Enable} false {Disable} other {Disable}} Allow Partial Fill',
  SC_PROMPT_MSG_TOGGLE_ALLOW_PARTIAL:
    'You are about to {enabled, select, true {enable} false {disable} other {disable}} the allow partial fill feature across the entire platform. Are you sure you want to continue?',
  TC_PROMPT_TITLE_TOGGLE_FIX_TRADE_QUERIES: '{enabled, select, true {Enable} false {Disable} other {Disable}} FIX Trade Queries',
  TC_PROMPT_TITLE_TOGGLE_CLUSTER_BATCHING: '{enabled, select, true {Enable} false {Disable} other {Disable}} Cluster Batching',
  TC_PROMPT_TITLE_TOGGLE_LIGHT_WEIGHT_PRICE: '{enabled, select, true {Enable} false {Disable} other {Disable}} Light Weight Price',
  TC_PROMPT_TITLE_TOGGLE_LIGHT_WEIGHT_PRICE_WEB: '{enabled, select, true {Enable} false {Disable} other {Disable}} Light Weight Price Web',
  TC_PROMPT_TITLE_TOGGLE_FIRDS: '{enabled, select, true {Enable} false {Disable} other {Disable}} Firds',
  TC_PROMPT_TITLE_TOGGLE_CORPORATES: '{enabled, select, true {Enable} false {Disable} other {Disable}} Corporates',
  TC_PROMPT_TITLE_TOGGLE_EVERGREENS: '{enabled, select, true {Enable} false {Disable} other {Disable}} Evergreens',
  TC_PROMPT_TITLE_TOGGLE_MBS: '{enabled, select, true {Enable} false {Disable} other {Disable}} MBSs',
  TC_PROMPT_TITLE_TOGGLE_SPREADSHEET_UNKNOWN_COLLATERAL:
    '{enabled, select, true {Enable} false {Disable} other {Disable}} Upload unknown collateral from spreadsheet',
  TC_PROMPT_TITLE_TOGGLE_REAL_TIME_PURGE:
    '{enabled, select, true {Enable} false {Disable} other {Disable}} real time purgingof tradeable data',
  TC_PROMPT_TITLE_TOGGLE_NEGOTIATION_INFLIGHT:
    '{enabled, select, true {Enable} false {Disable} other {Disable}} negotiation in flight data',
  SC_PROMPT_MSG_TOGGLE_CLUSTER_BATCHING:
    'You are about to {enabled, select, true {enable} false {disable} other {disable}} cluster batching feature. Are you sure you want to continue?',
  SC_PROMPT_MSG_TOGGLE_LIGHT_WEIGHT_PRICE:
    'You are about to {enabled, select, true {enable} false {disable} other {disable}} light weight price feature. Are you sure you want to continue?',
  SC_PROMPT_MSG_TOGGLE_LIGHT_WEIGHT_PRICE_WEB:
    'You are about to {enabled, select, true {enable} false {disable} other {disable}} light weight price web feature. Are you sure you want to continue?',
  SC_PROMPT_MSG_TOGGLE_FIRDS:
    'You are about to {enabled, select, true {enable} false {disable} other {disable}} firds feature. Are you sure you want to continue?',
  SC_PROMPT_MSG_TOGGLE_CORPORATES:
    'You are about to {enabled, select, true {switch on} false {switch off} other {switch off}} the mapping of Corporate collaterals. Are you sure you want to continue?',
  SC_PROMPT_MSG_TOGGLE_EVERGREENS:
    'You are about to {enabled, select, true {switch on} false {switch off} other {switch off}} the feature evergreens. Are you sure you want to continue?',
  SC_PROMPT_MSG_TOGGLE_MBS:
    'You are about to {enabled, select, true {switch on} false {switch off} other {switch off}} the mapping of MBS collaterals. Are you sure you want to continue?',
  SC_PROMPT_MSG_TOGGLE_SPREADSHEET_UNKNOWN_COLLATERAL:
    'You are about to {enabled, select, true {enable} false {disable} other {disable}} uploading spreadsheets with unknown collaterals. Are you sure you want to continue?',
  SC_PROMPT_MSG_TOGGLE_REAL_TIME_PURGE:
    'You are about to {enabled, select, true {enable} false {disable} other {disable}} real time purging of tradable data. Are you sure you want to continue?',
  SC_PROMPT_MSG_TOGGLE_NEGOTIATION_INFLIGHT:
    'You are about to {enabled, select, true {enable} false {disable} other {disable}} negotiation in flight data. Are you sure you want to continue?',
  SC_PROMPT_MSG_TOGGLE_FIX_TRADE_QUERIES:
    'You are about to {enabled, select, true {enable} false {disable} other {disable}} the trade queries via FIX feature. Are you sure you want to continue?',
  TC_PROMPT_TITLE_TOGGLE_ENABLE_CURVE_COLLECTIONS: '{enabled, select, true {Enable} false {Disable} other {Disable}} Curve OCO Collections',
  SC_PROMPT_MSG_TOGGLE_ENABLE_CURVE_COLLECTIONS:
    'You are about to {enabled, select, true {enable} false {disable} other {disable}} the Curve OCO Collections feature. Are you sure you want to continue?',
  TC_PROMPT_TITLE_TOGGLE_ENABLE_START_CONSIDERATION_OVERRIDE:
    '{enabled, select, true {Enable} false {Disable} other {Disable}} Start Consideration Override',
  SC_PROMPT_MSG_TOGGLE_ENABLE_START_CONSIDERATION_OVERRIDE:
    'You are about to {enabled, select, true {enable} false {disable} other {disable}} the Start Consideration Override feature. Are you sure you want to continue?',
  SC_CLIENT_LOGSTREAM_GLOBAL_WARNING_MESSAGE:
    'Diagnostics and general application errors are always reported and are unaffected by these settings',
  TC_CLIENT_LOGSTREAM_SEVERITY_NONE: 'None',
  TC_CLIENT_LOGSTREAM_SEVERITY_INFO: 'Info',
  TC_CLIENT_LOGSTREAM_SEVERITY_ERROR: 'Error',
  TC_CLIENT_LOGSTREAM_SEVERITY_WARN: 'Warn',
  TC_CLIENT_LOGSTREAM_LABEL_GLOBAL: 'Global',
  TC_CLIENT_LOGSTREAM_LABEL_ENTITYUPDATES: 'Entity Updates',

  // Refinitiv
  TC_PROMPT_TITLE_REFINITIV_PRICE_REQUEST: 'Refinitiv price request',
  SC_PROMPT_MSG_REFINITIV_PRICE_REQUEST: 'You are about to trigger a refinitiv price request - Are you sure you want to continue?',

  TC_PROMPT_TITLE_REFINITIV_COLLATERAL_REQUEST: 'Retry Collateral load',
  SC_PROMPT_MSG_REFINITIV_COLLATERAL_REQUEST: 'You are about to trigger retry Collateral load - Are you sure you want to continue?',

  TC_PROMPT_TITLE_REFINITIV_RIC_CODE_REQUEST: 'Collateral Refresh',
  SC_PROMPT_MSG_REFINITIV_RIC_CODE_REQUEST: 'You are about to trigger a refinitiv Collateral Refresh - Are you sure you want to continue?',

  TC_PROMPT_TITLE_REFINITIV_ISSUER_REFRESH_REQUEST: 'Issuer Org Refresh',
  SC_PROMPT_MSG_REFINITIV_ISSUER_REFRESH_REQUEST:
    'You are about to trigger a refinitiv Issuer Org Refresh - Are you sure you want to continue?',

  TC_PROMPT_TITLE_REFINITIV_NEW_FIELDS_REQUEST: 'Collateral New Fields',
  SC_PROMPT_MSG_REFINITIV_NEW_FIELDS_REQUEST:
    'You are about to trigger a refinitiv Collateral Fields Refresh - Are you sure you want to continue?',

  TC_PROMPT_TITLE_REFINITIV_CORPS_REFRESH_REQUEST: 'Collateral Corps Refresh',
  SC_PROMPT_MSG_REFINITIV_CORPS_REFRESH_REQUEST:
    'You are about to trigger a refinitiv Collateral Corps Refresh - Are you sure you want to continue?',

  // Order Record Keeping Admin
  TC_PROMPT_TITLE_TRIGGER_ORK_DUMP: 'Order Record Keeping Dump',
  SC_PROMPT_MSG_TRIGGER_ORK_DUMP: 'You are about to trigger an order record keeping dump - Are you sure you want to continue?',

  TC_PROMPT_TITLE_TRIGGER_TRANSACTION_REPORTING_DUMP: 'Transaction Reporting Dump',
  SC_PROMPT_MSG_TRIGGER_TRANSACTION_REPORTING_DUMP:
    'You are about to trigger an transaction reporting dump - Are you sure you want to continue?',

  TC_PROMPT_TITLE_TRIGGER_NEGOTIATION_EXPORT_DUMP: 'Negotiation Export Dump',
  SC_PROMPT_MSG_TRIGGER_NEGOTIATION_EXPORT_DUMP: 'You are about to trigger an negotiation export dump - Are you sure you want to continue?',

  TC_PROMPT_TITLE_TRIGGER_REFINITIV_IMPORT_REPORT: 'Refinitiv import reort',
  SC_PROMPT_MSG_TRIGGER_REFINITIV_IMPORT_REPORT: 'You are about to trigger a refinitiv import report - Are you sure you want to continue?',

  TC_PROMPT_TITLE_TRIGGER_DEAL_EXPORT_DUMP: 'Deal Export Dump',
  SC_PROMPT_MSG_TRIGGER_DEAL_EXPORT_DUMP: 'You are about to trigger an deal export dump - Are you sure you want to continue?',

  TC_PROMPT_TITLE_TRIGGER_SOTW: 'Egress SOTW',
  SC_PROMPT_MSG_TRIGGER_SOTW: 'You are about to trigger an writing SOTW onto the public egress - Are you sure you want to continue?',

  TC_PROMPT_TRIGGER_CALCULATE_END_CONSIDERATION: 'Calculate End Consideration',
  SC_PROMPT_MSG_TRIGGER_CALCULATE_END_CONSIDERATION:
    'You are about to trigger calculation of end consideration- Are you sure you want to continue?',

  TC_PROMPT_TRIGGER_COMPLETE_DEALS: 'Complete Deals',
  SC_PROMPT_MSG_TRIGGER_COMPLETE_DEALS: 'You are about to trigger completion of deals that are matured- Are you sure you want to continue?',

  TC_PROMPT_TRIGGER_FAILED_EXPORTS_RETRY: 'Retry Failed Exports',
  SC_PROMPT_MSG_TRIGGER_FAILED_EXPORTS_RETRY: 'You are about to trigger retry of exports that failed - Are you sure you want to continue?',

  TC_PROMPT_TRIGGER_FAILED_EXPORTS_DELETE: 'Delete Failed Exports',
  SC_PROMPT_MSG_TRIGGER_FAILED_EXPORTS_DELETE:
    'You are about to trigger deleting of exports that failed - Are you sure you want to continue?',

  TC_PROMPT_TRIGGER_PURGE_TRADE_DATA: 'Purge Trade Data',
  SC_PROMPT_MSG_TRIGGER_PURGE_TRADE_DATA: 'You are about to trigger purging all trade data - Are you sure you want to continue?',

  TC_PROMPT_TRIGGER_RESET_TEST_DATA: 'Reset Test Data',
  SC_PROMPT_MSG_TRIGGER_RESET_TEST_DATA: 'You are about to trigger resetting of test data - Are you sure you want to continue?',

  TC_PROMPT_TRIGGER_EOD_PURGE: 'EOD Purge',
  SC_PROMPT_MSG_TRIGGER_EOD_PURGE: 'You are about to trigger EOD purge - Are you sure you want to continue?',

  TC_PROMPT_TRIGGER_SET_CURRENT_TRADE_DATE: 'Current Trade Date',
  SC_PROMPT_MSG_TRIGGER_SET_CURRENT_TRADE_DATE: 'You are about to set the trade date to today - Are you sure you want to continue?',

  TC_PROMPT_TRIGGER_FIRDS_REPORT: 'Trigger Firds Report',
  SC_PROMPT_MSG_TRIGGER_FIRDS_REPORT: 'You are about to trigger generation of the Firds report - Are you sure you want to continue?',

  TC_PROMPT_TRIGGER_BOND_NOTE_UPDATE: 'Bonds Note Update',
  SC_PROMPT_MSG_TRIGGER_BOND_NOTE_UPDATE: 'You are about to trigger Bonds Note collateral updates - Are you sure you want to continue?',

  TC_PROMPT_TRIGGER_INCREMENT_IDS: 'Increment Ids',
  SC_PROMPT_MSG_TRIGGER_INCREMENT_IDS: 'You are about to trigger Incrementing all ids - Are you sure you want to continue?',

  TC_PROMPT_TRIGGER_OKTA_USERS_REPORT: 'Trigger Okta Report',
  SC_PROMPT_MSG_TRIGGER_OKTA_USERS_REPORT: 'You are about to trigger generation of the Okta report - Are you sure you want to continue?',

  TC_PROMPT_TRIGGER_UPDATE_MORTGAGE_FACTORS: 'Update Mort Factors',
  SC_PROMPT_MSG_TRIGGER_UPDATE_MORTGAGE_FACTORS:
    'You are about to trigger an update of the mortgage factors - Are you sure you want to continue?',

  TC_PROMPT_TRIGGER_COLLATERAL_MIGRATION: 'Collateral Migration',
  SC_PROMPT_MSG_TRIGGER_COLLATERAL_MIGRATION: 'You are about to trigger collateral migration - Are you sure you want to continue?',

  TC_PROMPT_TRIGGER_COLLATERAL_CLEAR_TRADE_DATE: 'Clear First Trade Date',
  SC_PROMPT_MSG_TRIGGER_COLLATERAL_CLEAR_TRADE_DATE:
    'You are about to trigger collateral clear first trade date - Are you sure you want to continue?',

  TC_PROMPT_TRIGGER_GENERATE_SCHEDULE_REPORT: 'Schedule Report',
  SC_PROMPT_MSG_TRIGGER_GENERATE_SCHEDULE_REPORT:
    'You are about to trigger generateion of the schedule report - Are you sure you want to continue?',

  TC_PROMPT_TRIGGER_SET_CURRENT_TRADE_DATE_TO_PREVIOUS_BUSINESS_DAY: 'Previous Business Day',
  SC_PROMPT_MSG_TRIGGER_SET_CURRENT_TRADE_DATE_TO_PREVIOUS_BUSINESS_DAY:
    'You are about to set the trade date to the previous business day - Are you sure you want to continue?',

  // Skip all holiday dates
  TC_PROMPT_TRIGGER_SKIP_HOLIDAY_DATES: 'Skip All Holidays',
  SC_PROMPT_MSG_TRIGGER_SKIP_HOLIDAY_DATES:
    'You are about to skip all holidays and set the trading date to next available active date - Are you sure you want to continue?',

  // General Admin
  TC_PROMPT_TITLE_SUSPEND_TRADING: 'Suspend Trading',
  TC_PROMPT_TITLE_ACTIVATE_TRADING: 'Activate Trading',
  TC_PROMPT_TITLE_UPDATE_FROM_REFINITIV: 'Update From Refinitiv',
  SC_TRADING: 'Trading',
  TC_PROMPT_TITLE_DELETE_ISSUER_ORGANISATION: 'Delete Issuer Organisation',
  SC_DELETE_ISSUER_ORGANISATION_MESSAGE: 'Are you sure you want to delete this Issuer Organisation?',

  // Organisation Admin
  SC_PROMPT_MSG_SUSPEND_SINGLE_ORG: 'Are you sure you want to suspend trading for organisation "{name}"?',
  SC_PROMPT_MSG_SUSPEND_MULTI_ORG: 'Are you sure you want to suspend trading for {count} organisations?',
  SC_PROMPT_MSG_ACTIVATE_SINGLE_ORG: 'Are you sure you want to activate trading for organisation "{name}"?',
  SC_PROMPT_MSG_ACTIVATE_MULTI_ORG: 'Are you sure you want to activate trading for {count} organisations?',
  TC_SHORT_CODE: 'Firm Code',

  // Trading Entity Admin
  SC_PROMPT_MSG_SUSPEND_SINGLE_TENT: 'Are you sure you want to suspend trading for trading entity "{name}"?',
  SC_PROMPT_MSG_SUSPEND_MULTI_TENT: 'Are you sure you want to suspend trading for {count} trading entities?',
  SC_PROMPT_MSG_ACTIVATE_SINGLE_TENT: 'Are you sure you want to activate trading for trading entity "{name}"?',
  SC_PROMPT_MSG_ACTIVATE_MULTI_TENT: 'Are you sure you want to activate trading for {count} trading entities?',
  TC_PUBLISHED_NAME: 'Published Name',
  TC_SHORT_NAME: 'Short Name',
  TC_SHORT_NAME_DEFAULT: 'SN Default',
  TC_FICC_NAME_DEFAULT: 'SN FICC',
  TC_TRADING_ENTITY_SHORT_NAME: 'Trading Entity Short Name',
  TC_GROUP: 'Group',
  TC_CODE: 'Code',
  TC_PRODUCT_SECTORS: 'Product Sectors',
  TC_SUPPORTED_COLLATERAL_BASKETS: 'Supported Baskets',
  SC_NO_TRADING_ENTITY_CLEARINGS: 'No trading entity clearing relationships available',
  SC_NO_TRADING_ENTITY_RELATIONSHIPS: 'No trading entity relationships available',
  SC_NO_FAT_FINGER_LIMITS: 'No Fat Finger Limits available',
  SC_NO_FAT_FINGER_SECTOR: 'There are no platform level limits for this sector',
  TC_SPONSORING_BANK: 'Sponsoring Bank',
  TC_US_SPONSORED_CLEARING: 'US Sponsored Clearing',
  TC_US_SPONSORED_CLEARING_BY_DEFAULT: 'Default',
  TC_INITIATOR_FICC_TO_INITIATOR_FIX: 'Initiator FICC to Initiator FIX',
  TC_INITIATOR_FICC_TO_RESPONDER_FIX: 'Initiator FICC to Responder FIX',
  TC_RESPONDER_FICC_TO_INITIATOR_FIX: 'Responder FICC to Initiator FIX',
  TC_RESPONDER_FICC_TO_RESPONDER_FIX: 'Responder FICC to Responder FIX',
  TC_INITIATOR_FICC_TO_INITIATOR_FIX_ABB: 'Init. FICC to Init. FIX',
  TC_INITIATOR_FICC_TO_RESPONDER_FIX_ABB: 'Init. FICC to Resp. FIX',
  TC_RESPONDER_FICC_TO_INITIATOR_FIX_ABB: 'Resp. FICC to Init. FIX',
  TC_RESPONDER_FICC_TO_RESPONDER_FIX_ABB: 'Resp. FICC to Resp. FIX',
  TC_MASTER_LEGAL_AGREEMENT_TYPE: 'Legal Agreement Type',
  TC_MASTER_LEGAL_AGREEMENTS: 'Master Legal Agreements',
  TC_DEFAULT_AGREEMENT: 'Default Agreement',
  SC_SELECT_MASTER_LEGAL_AGREEMENT: 'Select master legal agreement',
  SC_REMOVE_MASTER_LEGAL_AGREEMENTS: 'Remove all master legal agreements',

  // Clearing House Admin
  TC_CLEARING_HOUSE_MIC: 'MIC',
  TC_CLEARING_HOUSE_LEI: 'LEI',
  TC_CLEARING_HOUSE_BIC: 'BIC',
  TC_CLEARING_HOUSE_INTEGRATION_READY: 'Integration Ready',

  // User Admin
  TC_PROMPT_TITLE_DISABLE_SINGLE_USER: 'Disable User',
  TC_PROMPT_TITLE_DISABLE_MULTI_USER: 'Disable Users',
  TC_PROMPT_TITLE_ENABLE_SINGLE_USER: 'Enable User',
  TC_PROMPT_TITLE_ENABLE_MULTI_USER: 'Enable Users',
  TC_PROMPT_TITLE_SIGN_OUT_SINGLE_USER: 'Sign out user',
  TC_PROMPT_TITLE_SIGN_OUT_MULTI_USER: 'Sign out users',
  SC_PROMPT_MSG_SUSPEND_SINGLE_USER: 'Are you sure you want to suspend trading for user "{name}"?',
  SC_PROMPT_MSG_SUSPEND_MULTI_USER: 'Are you sure you want to suspend trading for {count} users?',
  SC_PROMPT_MSG_ACTIVATE_SINGLE_USER: 'Are you sure you want to activate trading for user "{name}"?',
  SC_PROMPT_MSG_ACTIVATE_MULTI_USER: 'Are you sure you want to activate trading for {count} users?',
  SC_PROMPT_MSG_DISABLE_SINGLE_USER: 'Are you sure you want to disable user "{name}"?',
  SC_PROMPT_MSG_DISABLE_MULTI_USER: 'Are you sure you want to disable {count} users?',
  SC_PROMPT_MSG_ENABLE_SINGLE_USER: 'Are you sure you want to enable user "{name}"?',
  SC_PROMPT_MSG_ENABLE_MULTI_USER: 'Are you sure you want to enable {count} users?',
  SC_PROMPT_MSG_SIGN_OUT_SINGLE_USER: 'Are you sure you want to sign out user "{name}"?',
  SC_PROMPT_MSG_SIGN_OUT_MULTI_USER: 'Are you sure you want to sign out {count} users?',
  TC_PRIMARY_MARKET_TYPE: 'Primary Market',
  TC_SECONDARY_MARKET_TYPE: 'Secondary Market',

  // Collateral Admin
  SC_PROMPT_MSG_SUSPEND_SINGLE_COLLATERAL: 'Are you sure you want to suspend trading for collateral "{name}"?',
  SC_PROMPT_MSG_SUSPEND_MULTI_COLLATERAL: 'Are you sure you want to suspend trading for {count} collaterals?',
  SC_PROMPT_MSG_ACTIVATE_SINGLE_COLLATERAL: 'Are you sure you want to activate trading for collateral "{name}"?',
  SC_PROMPT_MSG_ACTIVATE_MULTI_COLLATERAL: 'Are you sure you want to activate trading for {count} collaterals?',
  SC_PROMPT_MSG_UPDATE_FROM_REFINITIV:
    'This will overwrite all existing details with the latest values from Refinitiv, do you wish to continue?',

  // Collateral Basket Admin
  SC_PROMPT_MSG_SUSPEND_SINGLE_COLLATERAL_BASKET: 'Are you sure you want to suspend trading for basket "{name}"?',
  SC_PROMPT_MSG_SUSPEND_MULTI_COLLATERAL_BASKET: 'Are you sure you want to suspend trading for {count} baskets?',
  SC_PROMPT_MSG_ACTIVATE_SINGLE_COLLATERAL_BASKET: 'Are you sure you want to activate trading for basket "{name}"?',
  SC_PROMPT_MSG_ACTIVATE_MULTI_COLLATERAL_BASKET: 'Are you sure you want to activate trading for {count} baskets?',
  TC_PROMPT_TITLE_DELETE_COLLATERAL_BASKET: 'Delete Collateral {count, plural, =1 {Basket} other {Baskets}}',
  SC_PROMPT_MSG_DELETE_SINGLE_COLLATERAL_BASKET: 'Are you sure you want to delete basket "{name}"?',
  SC_PROMPT_MSG_DELETE_MULTI_COLLATERAL_BASKET: 'Are you sure you want to delete {count} baskets?',

  // Collateral Basket Type
  TC_BASKET_TYPE_DBV: 'DBV',
  TC_BASKET_TYPE_EUROCLEAR: 'Euroclear',
  TC_BASKET_TYPE_GC_BESPOKE: 'GC Bespoke',
  TC_BASKET_TYPE_BONY: 'BONY',
  TC_BASKET_TYPE_GC_PLUS: 'GC Plus',
  TC_BASKET_TYPE_CLEAR_STREAM: 'Clearstream',
  TC_BASKET_TYPE_CASH: 'Cash',
  TC_BASKET_TYPE_COLLATERAL: 'Collateral',

  // Collateral Basket Trading Type
  TC_BASKET_TRADING_CASH: 'Cash',
  TC_BASKET_TRADING_NOTIONAL: 'Notional',
  TC_BASKET_TRADING_EITHER: 'Either',

  // Fat Finger Limit Admin
  TC_PROMPT_TITLE_DELETE_FAT_FINGER_LIMIT: 'Delete Fat Finger {count, plural, =1 {Limit} other {Limits}}',
  SC_PROMPT_MSG_DELETE_SINGLE_FAT_FINGER_LIMIT: 'Are you sure you want to delete fat finger limit "{name}"?',
  SC_PROMPT_MSG_DELETE_MULTI_FAT_FINGER_LIMIT: 'Are you sure you want to delete {count} fat finger limits?',

  // Holiday Admin
  TC_PROMPT_TITLE_DELETE_HOLIDAY: 'Delete {count, plural, =1 {Holiday} other {Holidays}}',
  SC_PROMPT_MSG_DELETE_SINGLE_HOLIDAY: 'Are you sure you want to delete holiday "{date}"?',
  SC_PROMPT_MSG_DELETE_MULTI_HOLIDAY: 'Are you sure you want to delete {count} holidays?',

  // Index Admin
  SC_PROMPT_MSG_SUSPEND_SINGLE_INDEX: 'Are you sure you want to suspend trading for index "{name}"?',
  SC_PROMPT_MSG_SUSPEND_MULTI_INDEX: 'Are you sure you want to suspend trading for {count} indices?',
  SC_PROMPT_MSG_ACTIVATE_SINGLE_INDEX: 'Are you sure you want to activate trading for index "{name}"?',
  SC_PROMPT_MSG_ACTIVATE_MULTI_INDEX: 'Are you sure you want to activate trading for {count} indices?',
  TC_PROMPT_TITLE_DELETE_INDEX: 'Delete {count, plural, =1 {Index} other {Indices}}',
  SC_PROMPT_MSG_DELETE_SINGLE_INDEX: 'Are you sure you want to delete index "{name}"?',
  SC_PROMPT_MSG_DELETE_MULTI_INDEX: 'Are you sure you want to delete {count} indices?',

  // User Dialog
  TC_USER_DETAILS: 'User Details',
  TC_PRODUCTS: 'Products',
  TC_PERMISSIONS: 'Permissions',
  TC_TRADING_ENTITIES: 'Trading Entities',
  TC_NOTES: 'Notes',
  TC_NEW_USER: 'Add New User',
  TC_VIEW: 'View',
  TC_WRITE: 'Write',
  TC_TRADE: 'Trade',
  TC_PASSPORT_UK: 'Passport UK',
  TC_PASSPORT_EU: 'Passport EU/ NI EU/ CONCAT',
  TC_PASSPORT_NIUK: 'NI UK',
  TC_FEATURE_TOGGLE: 'Feature Toggle',
  SC_ORGANISATION: 'Organisation',
  SC_ORGANISATION_PLACEHOLDER: 'Select an organisation',
  SC_USER_STATUS: 'User status',
  SC_FIRST_NAME: 'First name',
  SC_LAST_NAME: 'Last name',
  SC_EMAIL: 'Email',
  SC_CONTACT_NUMBER: 'Contact number',
  SC_ALGO_NAME: 'Algo name',
  SC_ACCOUNT_USER_NAME: 'Account user name',
  SC_SHORT_ID: 'Short ID',
  SC_SELECT_ORGANISATION_MESSAGE: 'Please select an organisation in the user details tab',
  SC_NO_PRODUCTS_AVAILABLE: 'No products available',
  SC_ALL_TRADING_ENTITIES: 'All trading entities',
  SC_AUTOMATICALLY_ADD_NEW_ENTITIES: 'Automatically add new entities',
  TC_PROMPT_TITLE_DELETE_USER: 'Delete User',
  SC_PROMPT_MSG_DELETE_USER:
    'You are about to delete this user. Once deleted you will no longer be able to update this user. Are you sure you want to continue?',
  SC_OKTA_STATUS: 'OKTA status',
  SC_OKTA_LAST_LOGIN: 'Last login date/time',

  // Haircut Dialog
  TC_ADD_NEW_HAIRCUT: 'Add New Haircut',
  TC_EDIT_HAIRCUT: 'Edit Haircut',
  TC_HAIRCUT_ALL_PRODUCTS: 'All',
  TC_HAIRCUT_ALL_PRODUCT_SECTORS: 'All',
  TC_HAIRCUT_ALL_COLLATERAL_BANDS: 'All',
  SC_HAIRCUT_SELL_FIRM_LABEL: 'Sell-side firm',
  SC_HAIRCUT_SELL_ENTITY_LABEL: 'Sell-side entity',
  SC_HAIRCUT_MY_FIRM_LABEL: 'My firm',
  SC_HAIRCUT_MY_ENTITY_LABEL: 'My entity',
  SC_HAIRCUT_COUNTERPARTY_FIRM_LABEL: 'Counterparty firm',
  SC_HAIRCUT_COUNTERPARTY_LABEL: 'Counterparty',
  SC_HAIRCUT_PRODUCT_LABEL: 'Product',
  SC_HAIRCUT_PRODUCT_SECTOR_LABEL: 'Product Sector',
  SC_HAIRCUT_HAIRCUT_COLLATERAL_BAND_LABEL: 'Collateral Maturity',
  TC_COLLATERAL_HAIRCUT: 'Collateral/Haircut',

  // Trade Split/Sales Cover Dialog
  TC_NEW_TRADE_SPLIT: 'Add New Trade Split',
  TC_NEW_SALES_COVERAGE: 'Add New Sales Coverage Entry',
  SC_ORGANISATION_META_MY_FIRM: 'My firm',
  SC_ORGANISATION_META_MY_ENTITY: 'My entity',
  SC_ORGANISATION_META_COUNTERPARTY_FIRM: 'Counterparty firm',
  SC_ORGANISATION_META_COUNTERPARTY: 'Counterparty',
  SC_ORGANISATION_META_PRODUCT: 'Product',
  SC_ORGANISATION_META_PRODUCT_SECTOR: 'Product sector',
  SC_TRADE_SPLIT_SPLIT_TRADES: 'Split Trades',
  SC_TRADE_SPLIT_SPLIT_AMOUNT: 'Split Trade Amount',
  TC_ORGANISATION_META_ALL: 'All',
  SC_BOTH_COVER_USERS_NOT_SET: 'At least one of primary or secondary sales cover users must be set',
  SC_DUPLICATE_ORGANISATION_META: 'One (or more) matching rows already exist',

  // Organisation Dialog
  TC_NEW_ORGANISATION: 'Add New Organisation',
  TC_ORGANISATION_DETAILS: 'Organisation Details',
  TC_ORGANISATION_PRIME_BROKERS: 'Prime Brokers',
  TC_ORGANISATION_TRADE_SPLITS: 'Trade Splits',
  TC_ORGANISATION_SALES_COVERAGE: 'Sell Side Sales Coverage',
  TC_GFID: 'GFID',
  TC_SMART_GROUPING_TOGGLE: 'Smart Grouping',
  TC_PRE_ASSIGNMENT_TOGGLE: 'Pre Assignment',
  TC_GRID_VIEW_TOGGLE: 'Grid View',
  TC_CUMULATIVE_RECONCILIATION_TOGGLE: 'Cumulative Reconciliation File',
  TC_LOCK_FIX_TOGGLE: 'Lock FIX orders in Staging',
  SC_SHORT_CODE: 'Firm code',
  SC_ORGANISATION_LEI: 'LEI',
  SC_LEGAL_NAME: 'Legal Name',
  SC_ORGANISATION_TYPE: 'Organisation type',
  SC_SELECT_ORGANISATION_TYPE: 'Select an organisation type',
  SC_REMOVE_ORGANISATION_TYPES: 'Remove all organisation types',
  SC_ORGANISATION_TYPE_PLACEHOLDER: 'Select organisation type',
  SC_EMAIL_ENABLED: 'Email enabled',
  SC_SFTP_ENABLED: 'SFTP enabled',
  SC_ADD_PRIME_BROKER: 'Add a prime broker',
  SC_REMOVE_PRIME_BROKERS: 'Remove all prime brokers',
  SC_NO_TRADE_SPLITS: 'No trade splits available',
  SC_NO_SALES_COVERAGE: 'No sales coverage available',
  SC_START_CONSIDERATION_OVERRIDE_ENABLED: 'Start Consideration Override Enabled',
  SC_FIX_PERCENTAGE_FORMAT_ENABLED: 'FIX Percentage Format',
  SC_STOCK_BORROW_LENDING: 'SBL',
  SC_ADD_GFID: 'Add a gfid',
  SC_REMOVE_GFIDS: 'Remove all gfids',

  // Add Prime Broker Dialog
  TC_ADD_PRIME_BROKER: 'Add Prime Broker',
  SC_ADD_PRIME_BROKER_MY_ENTITY: 'My entity',
  SC_ADD_PRIME_BROKER_COUNTERPARTY: 'Counterparty',
  SC_ADD_PRIME_BROKER_PRIME_BROKER: 'Prime Broker',

  // Prime Broker Defaults
  TC_PRIME_BROKER_DEFAULTS_COUNTERPARTY_NAME: 'Counterparty Name',
  TC_PRIME_BROKER_DEFAULTS_PRIME_BROKER: 'Prime Broker',

  // Add Alias Dialog
  TC_ADD_NEW_ALIAS: 'Add New Alias',
  TC_EDIT_ALIAS: 'Edit Alias',
  UC_ALIAS_TYPE_ALL: 'ALL',
  UC_ALIAS_TYPE_FICC: 'FICC',
  SC_ALIAS_MY_ENTITY: 'My entity',
  SC_ALIAS_COUNTERPARTY: 'Counterparty',
  SC_ALIAS_TYPE: 'Alias type',

  // TradingEntity Dialog
  TC_NEW_TRADING_ENTITY: 'Add New Trading Entity',
  TC_TRADING_ENTITY_DETAILS: 'Trading Entity Details',
  TC_INITIATOR_RELATIONSHIPS: 'Initiator Relationships',
  TC_RESPONDER_RELATIONSHIPS: 'Responder Relationships',
  TC_ALIASES: 'Aliases',
  SC_SHORT_NAME: 'Default Short name',
  SC_FICC_SHORT_NAME: 'FICC Short name',
  SC_PUBLISHED_NAME: 'Published name',
  SC_TRADING_ENTITY_LEI: 'LEI',
  SC_BIC: 'BIC',
  TC_TRADING_ENTITY_TYPE: 'Trading Entity Type',
  TC_DIRECT_TRADING_ENTITY_CLEARING: 'Direct Clearing Relationships',
  TC_SPONSORED_TRADING_ENTITY_CLEARING: 'Sponsored Clearing Relationships',
  TC_BUTTON_NEW_DIRECT_TRADING_ENTITY_CLEARING: 'Add Direct Clearing Relationship',
  TC_BUTTON_NEW_SPONSORED_TRADING_ENTITY_CLEARING: 'Add Sponsored Clearing Relationship',
  TC_BUTTON_EDIT_DIRECT_TRADING_ENTITY_CLEARING: 'Edit Direct Clearing Relationship',
  TC_BUTTON_EDIT_SPONSORED_TRADING_ENTITY_CLEARING: 'Edit Sponsored Clearing Relationship',
  TC_PROMPT_TITLE_ACTIVATE_SINGLE_TRADING_ENTITY_CLEARING: 'Activate clearing relationship',
  SC_PROMPT_MSG_ACTIVATE_SINGLE_TRADING_ENTITY_CLEARING:
    'Are you sure you want to activate the clearing relationship with "{clearingHouseName}"?',
  TC_PROMPT_TITLE_SUSPEND_SINGLE_TRADING_ENTITY_CLEARING: 'Suspend clearing relationship',
  SC_PROMPT_MSG_SUSPEND_SINGLE_TRADING_ENTITY_CLEARING:
    'Are you sure you want to suspend the clearing relationship with "{clearingHouseName}"?',
  TC_PROMPT_TITLE_DELETE_SINGLE_TRADING_ENTITY_CLEARING: 'Delete clearing relationship',
  SC_PROMPT_MSG_DELETE_SINGLE_TRADING_ENTITY_CLEARING:
    'Are you sure you want to delete the clearing relationship with "{clearingHouseName}"?',
  TC_15A6_ELIGIBLE: '15a6 Eligible',
  TC_COMBINED_EU_US_EOD_FILE: 'Combined EU/US EOD File',
  TC_CENTRAL_BANK: 'Central Bank',
  TC_NEGOTIATION_HISTORY_FILE: 'Negotiation History File',
  TC_ROUND_PRICE_TO_EIGHT: 'Round price to 1/8th',
  TC_TRADING_ENTITY_RELATIONSHIPS: 'Trading Entity Relationships',
  TC_NEW_TRADING_ENTITY_RELATIONSHIP: 'Add Trading Entity Relationship',
  TC_EDIT_TRADING_ENTITY_RELATIONSHIP: 'Edit Trading Entity Relationship',
  TC_PROMPT_TITLE_DELETE_SINGLE_TRADING_RELATIONSHIP: 'Delete trading relationship',
  SC_PROMPT_MSG_DELETE_SINGLE_TRADING_RELATIONSHIP: 'Are you sure you want to delete the trading relationship with "{tradingEntityName}"?',
  TC_BUTTON_VIEW_SPONSORED_TRADING_ENTITY_CLEARING: 'View Sponsored Clearing Relationship',
  TC_BUTTON_VIEW_DIRECT_TRADING_ENTITY_CLEARING: 'View Direct Clearing Relationship',
  TC_EU_GFID: 'EU GFID',
  TC_US_GFID: 'US GFID',
  TC_OPERATING_COUNTRY: 'Operating Country',

  // TradingEntityAlias Dialog
  TC_TRADING_ENTITY_ALIAS: 'Trading Entity Alias',
  TC_NO_ALIASES: 'No Aliases',
  TC_PROMPT_TITLE_SET_TRADING_ENTITY_ALIAS: 'Set Trading Entity Alias',
  SC_PROMPT_MSG_SET_TRADING_ENTITY_ALIAS_FOR_ALL:
    'Do you want to set the alias "{newAlias}" for counterparty "{counterpartyName}" across all your trading entities?',
  SC_PROMPT_MSG_REMOVE_TRADING_ENTITY_ALIAS_FOR_ALL:
    'Do you want to remove the alias "{alias}" for counterparty "{counterpartyName}" across all your trading entities?',
  TC_PROMPT_TITLE_SET_TRADING_ENTITY_PRIME_BROKER: 'Set Prime Broker',
  SC_PROMPT_MSG_SET_TRADING_ENTITY_PRIME_BROKER_FOR_ALL:
    'Do you want to set the prime broker "{newPrimeBroker}" for counterparty "{counterpartyName}" across all your trading entities?',
  SC_PROMPT_MSG_REMOVE_TRADING_ENTITY_PRIME_BROKER_FOR_ALL:
    'Do you want to remove the prime broker "{primeBroker}" for counterparty "{counterpartyName}" across all your trading entities?',

  // Collateral Dialog
  TC_ADD_NEW_COLLATERAL: 'Add New Collateral',
  SC_COLLATERAL_SHORT_ID: 'Short ID',
  SC_PLATFORM: 'Platform',
  SC_ISIN: 'ISIN',
  SC_FISN: 'FISN',
  SC_CFI: 'CFI',
  SC_CUSIP: 'CUSIP',
  SC_CURRENCY: 'Currency',
  SC_COUNTRY: 'Country',
  SC_SECTOR: 'Sector',
  SC_PRODUCT: 'Product',
  SC_ISSUER: 'Issuer',
  TC_ISSUER_LEI: 'Issuer LEI',
  TC_NOT_ISSUER_LEI: 'Not Issuer LEI',
  SC_TRADING_TYPE: 'Trading type',
  SC_COLLATERAL_STATUS: 'Collateral Status',
  SC_FIRST_SETTLEMENT_DATE: 'First settlement date',
  SC_CLEAN_PRICE: 'Clean price',
  SC_BASIS_CONVENTION: 'Basis convention',
  TC_MINIMUM_TICKET_SIZE: 'Minimum Ticket Size',
  TC_TICKET_SIZE_INCREMENT: 'Ticket Size Increment',
  SC_TICKET_SIZE: 'Ticket size',
  SC_MAX_TICKET_SIZE: 'Max ticket size',
  SC_COLLATERAL_TYPE: 'Collateral type',
  SC_COLLATERAL_INDEX: 'Index',
  SC_COLLATERAL_INDEX_LAG: 'Lag',
  SC_COLLATERAL_BASE_INDEX_VALUE: 'Base index value',
  SC_COUPON_TYPE: 'Coupon type',
  SC_COUPON: 'Coupon',
  SC_ACCRUAL_DATE: 'Accrual date',
  SC_FIRST_COUPON_DATE: 'First coupon date',
  SC_FIRST_TRADE_DATE: 'First trade date',
  SC_MATURITY_DATE: 'Maturity date',
  SC_FREQUENCY: 'Frequency',
  SC_TOTAL_ISSUED_NOMINAL_AMOUNT: 'Total issued nominal amount',
  TC_RFA: 'RFA',
  SC_PROSPECTUS: 'Prospectus',
  SC_CORP_COLLATERAL_SUSPENDED_MESSAGE:
    'EU Corporate collateral cannot be set to Active if any compliance flags are not Y. In this case please set the compliance over ride to TRUE',
  SC_MORT_COLLATERAL_SUSPENDED_MESSAGE: 'EU MBS collateral cannot be set to Active if no compliance flags are Y',
  SC_INDEX_SPREAD: 'Index spread',
  SC_SENIORITY: 'Seniority',
  SC_RIC: 'RIC',
  SC_SYSTEM: 'system',
  TC_MAIN_DETAILS: 'Main Details',
  TC_ADDITIONAL_DETAILS: 'Additional Details',
  TC_BOND_TYPE: 'Bond Type',
  TC_CALLABLE_FLAG: 'Callable Flag',
  TC_COUNTRY_OF_INCORPORATION: 'Country of Incorporation',
  TC_NOT_COUNTRY_OF_INCORPORATION: 'Not Country of Incorporation',
  TC_COUNTRY_OF_ISSUANCE: 'Country of Issuance',
  TC_NOT_COUNTRY_OF_ISSUANCE: 'Not Country of Issuance',
  TC_COUNTRY_OF_RISK_ALL: 'Country of Risk - All',
  TC_COUNTRY_OF_RISK_PRIMARY: 'Country of Risk - Primary',
  TC_COUNTRY_OF_RISK_ULTIMATE_PARENT_ALL: 'Country of Risk - Ultimate - Parent - All',
  TC_COUNTRY_OF_RISK_ULTIMATE_PARENT_PRIMARY: 'Country of Risk- Ultimate - Parent - Primary',
  TC_COUPON_RATE_EFFECTIVE_DATE: 'Coupon Rate Effective Date',
  TC_DOMICILE: 'Domicile',
  TC_ECB_INDICATOR: 'ECB Indicator',
  TC_EX_DIVIDEND_CALENDAR: 'Ex-dividend Calendar',
  TC_EX_DIVIDEND_RULE: 'Ex-dividend Rule',
  TC_EX_DIVIDEND_VALUE: 'Ex-dividend Value',
  TC_FACTOR: 'Factor',
  TC_FACTOR_DATE: 'Factor Date',
  TC_MBS_PRICE_DATE: 'MBS Price Date',
  TC_FITCH_RATING: 'Fitch Rating',
  TC_FLOAT_INDEX_TYPE: 'Float Index Type',
  TC_FLOAT_MULTIPLIER: 'Float Multiplier',
  TC_FLOAT_OFFSET: 'Float Offset',
  TC_FLOATER_FLAG: 'Floater Flag',
  TC_FLOATING_RATE_FIXING_DATE: 'Floating Rate Fixing Date',
  TC_INDUSTRY_SECTOR_CODE: 'Industry Sector Code',
  TC_INDUSTRY_SUB_SECTOR_CODE: 'Industry Sub-Sector Code',
  TC_IS_SECURED_FLAG: 'Is Secured Flag',
  TC_ISSUER_ORG_ID: 'Issuer OrgID',
  TC_LOOK_BACK: 'Lookback',
  TC_MIFID_INDEX_IDENTIFIER: 'MiFID Index Identifier',
  TC_MIFID_INDEX_NAME: 'MiFID Index Name',
  TC_MIFID_INDEX_TERM: 'MiFID Index Term',
  TC_MOODYS_RATING: 'Moodys Rating',
  TC_MULTI_STEP_FLOAT_FLAG: 'Multi-Step Float Flag',
  TC_OFFERING_TYPE: 'Offering Type',
  TC_PERPETUAL_SECURITY_FLAG: 'Perpetual Security Flag',
  TC_PRIVATE_PLACEMENT_FLAG: 'Private Placement Flag',
  TC_REFINITIV_CLASSIFICATION_SCHEME: 'Refinitiv Classification Scheme',
  TC_REGULATION_S_INDICATOR: 'Regulation S Indicator',
  TC_RULE_144A_INDICATOR: 'Rule 144a Indicator',
  TC_S_AND_P_RATING: 'S&P Rating',
  TC_SETTLEMENT_DATE_CONVENTION: 'Settlement Date Convention',
  TC_SINKABLE_FLAG: 'Sinkable Flag',
  TC_TOTAL_AMOUNT_OUTSTANDING: 'Total Amount Outstanding',
  TC_COLLATERAL_SAVE_CONFIRMATION: 'Save Collateral Changes',
  TC_ASSET_TYPE: 'Asset Type',
  TC_BTQ_ASSET_TYPE: 'BTQ Asset Type',
  TC_REFINITIV_ASSET_TYPE: 'Refinitiv Asset Type',
  TC_ASSET_SUB_TYPE: 'Asset Sub Type',
  TC_ASSET_DEBT_TYPE: 'Debt Type',
  TC_MORT_AGENCY_ASSET_TYPE: 'MORT - AGENCY',
  TC_MORT_NON_AGENCY_ASSET_TYPE: 'MORT - NON AGENCY',
  TC_ASSET_STATUS: 'Asset Status',
  TC_ASSET_STATUS_EFFECTIVE_DATE: 'Asset Status Effective Date',
  TC_RECOGNISED_EXCHANGE: 'Recognised Exchange',
  TC_IN_ESMA_FIRDS: 'In Esma FIRDS',
  TC_EEA_VENUE_ELIGIBLE: 'EEA Venue Eligible',
  TC_UK_VENUE_ELIGIBLE: 'UK Venue Eligible',
  TC_COMPLIANCE_OVERRIDE: 'Compliance Override',
  TC_MIC_REPORT_DATE: 'MIC Report Date',
  SC_COLLATERAL_REPORTING_WARNING_MESSAGE: 'This change may result in a change to reporting of this collateral',
  TC_SERIES: 'Series',
  TC_ISSUE: 'Issue',
  TC_ROE: 'RoE',
  TC_ROS: 'RoS',
  TC_ISSUER_ULTIMATE_PARENT_SUSPENDED_MESSAGE: 'Please check the Issuer or Ultimate Parent and try again',
  TC_NEW_OR_OLD_COLLATERAL_PRICE: 'Would you like to keep the original collateral price(s) for this close open?',
  // Collateral Basket Dialog
  TC_ADD_NEW_COLLATERAL_BASKET: 'Add Basket',
  TC_BASKET_OWNER: 'Basket Owner',
  TC_TRADING_TYPE: 'Trading Type',
  TC_CALCULATE_ACCRUED_INTEREST_QUESTION: 'Calculate Accrd. Interest?',
  TC_IS_DYNAMIC_BASKET_QUESTION: 'Is Basket Dynamic?',
  TC_SELECTED_PRODUCTS: 'Selected Products',
  TC_MATCHING_RESULTS: 'Matching Results',
  TC_SELECTED_ORGANISATIONS: 'Selected Organisations',
  TC_SECONDARY_COLLATERAL: 'Secondary Collateral',
  TC_SELECTED_SECONDARY_COLLATERALS: 'Selected Secondary Collaterals',
  SC_BASKET_NAME_PLACEHOLDER: 'Enter a unique name',
  SC_BASKET_DESCRIPTION_PLACEHOLDER: 'Provide a detailed description for this basket',
  SC_CME_BASKET_REFERENCE_PLACEHOLDER: 'Provide a CME Basket Reference for this basket',
  SC_PLEASE_SELECT: 'Please select',
  SC_NO_COLLATERAL_EUROCLEAR: 'No collateral is required to be selected for Euroclear Baskets',
  SC_NO_COLLATERAL_DBV: 'No collateral is required to be selected for DBV Baskets',
  SC_NO_COLLATERAL_BONY: 'No collateral is required to be selected for BONY Triparty baskets',
  SC_NO_COLLATERAL_GC_PLUS: 'No collateral is required to be selected for GC Plus baskets',
  SC_NO_COLLATERAL_COLLATERAL: 'No collateral is required to be selected for Collateral baskets',
  SC_NO_COLLATERAL_CASH: 'No collateral is required to be selected for Cash Triparty baskets',
  SC_NO_COLLATERAL_CLEAR_STREAM: 'No collateral is required to be selected for Clearstream Triparty baskets',
  SC_NO_PERMISSIONS_COLLATERAL: 'No permissions are required to be selected for Collateral baskets',
  SC_NO_PERMISSIONS_CASH: 'No permissions are required to be selected for Cash Triparty baskets',

  // Clearing House Dialog
  SC_NO_COLLATERALS_AVAILABLE: 'No collaterals available',
  SC_NO_BASKETS_AVAILABLE: 'No baskets available',
  TC_DIRECT_CLEARING: 'Direct Clearing',
  TC_SPONSORED_CLEARING: 'Sponsored Clearing',
  UC_ON: 'ON',
  UC_OFF: 'OFF',
  TC_COLLATERAL_SHORT_ID: 'Collateral Short ID',
  TC_CLEARING: 'Clearing',
  TC_CLEARING_HOUSE_DETAILS: 'Clearing House Details',
  TC_EDIT_CLEARING_HOUSE_DETAILS: 'Edit Clearing House Details',
  TC_VIEW_CLEARING_HOUSE_DETAILS: 'View Clearing House Details',

  // Clearing Info Dialog
  TC_CLEARING_INFO: 'SWIFT Interaction',
  TC_CLEARING_MESSAGE_SUMMARY: 'Summary',
  TC_CLEARING_MESSAGE_ID: 'Id',
  TC_CLEARING_MESSAGE_TYPE: 'Type',
  TC_CLEARING_REQUEST_DETAILS: 'Request Details',
  TC_CLEARING_REQUEST_SENT_AT: 'Request Sent At',
  TC_CLEARING_REQUEST_CONTENT: 'Request Content',
  TC_CLEARING_PENDING_RESPONSE_DETAILS: 'Pending Response Details',
  TC_CLEARING_PENDING_RESPONSE_RECEIVED_AT: 'Pending Response Received At',
  TC_CLEARING_PENDING_RESPONSE_CONTENT: 'Pending Response Content',
  TC_CLEARING_RESPONSE_DETAILS: 'Response Details',
  TC_CLEARING_RESPONSE_RECEIVED_AT: 'Response Received At',
  TC_CLEARING_RESPONSE_CONTENT: 'Response Content',
  TC_CLEARING_ERROR_CONTENT: 'Error',
  TC_CLEARING_ERROR_AT: 'Error At',
  TC_CLEARING_ERROR_RESOLUTION_CONTENT: 'Error Resolution',
  TC_CLEARING_ERROR_RESOLUTION_AT: 'Error Resolved At',
  TC_CLEARING_MANUALLY_ACCEPTED: 'Manually Accepted',
  TC_CLEARING_MANUALLY_REJECTED: 'Manually Rejected',

  TC_VIEW_INTERACTION_DETAILS: 'View',
  SC_NO_CLEARING_INTERACTIONS_AVAILABLE: 'No SWIFT interactions',

  // Fat Finger Limit Dialog
  TC_NEW_FAT_FINGER_LIMIT: 'Add New Fat Finger Limit',
  TC_EDIT_FAT_FINGER_LIMIT: 'Edit Fat Finger Limit',
  SC_FIXED_RATE_PRICE: 'Fixed rate price (%)',
  SC_FIXED_RATE_WARN_LEVEL: 'Fixed rate warn level (BP)',
  SC_FIXED_RATE_RESTRICTION: 'Fixed rate restriction (BP)',
  SC_FLOAT_RATE_SPREAD: 'Float rate spread (BP)',
  SC_FLOAT_RATE_WARN_LEVEL: 'Float rate warn level (BP)',
  SC_FLOAT_RATE_RESTRICTION: 'Float rate restriction (BP)',
  SC_NOTIONAL_AMOUNT_WARN: 'Notional amount warn (M)',
  SC_NOTIONAL_AMOUNT_RESTRICTION: 'Notional amount restriction (M)',
  SC_CASH_AMOUNT_WARN: 'Cash amount warn (M)',
  SC_CASH_AMOUNT_RESTRICTION: 'Cash amount restriction (M)',

  // Holiday Dialog
  TC_NEW_HOLIDAY: 'New Holiday',
  SC_HOLIDAY_CURRENCY: 'Currency',
  SC_HOLIDAY: 'Holiday',

  // Index Dialog
  TC_NEW_INDEX: 'New Index',
  TC_VIEW_INDEX: 'View Index',
  TC_BLOOMBERG_INDEX_CODE: 'Bloomberg Index Code',
  TC_REFINITIV_BASE_INDEX: 'Refinitiv Base Index',
  TC_HISTORICAL_PRICES: 'Historical Prices',
  TC_INDEX_PRICE: 'Index Price',
  SC_NO_PRICES_ERROR: 'No prices have been entered',
  SC_ENTER_PRICES: 'Please enter some prices',
  SC_BLOOMBERG_INDEX_CODE_PLACEHOLDER: 'Enter a unique index code',
  SC_BLOOMBERG_INDEX_DESCRIPTION_PLACEHOLDER: 'Provide a description',
  SC_PRICE_PLACEHOLDER: 'Price',
  SC_VALID_FOR_PLACEHOLDER: 'mmm/yyyy',
  SC_LAG: 'Lag',

  // Control Limit Dialog
  TC_NEW_TRADE_CONTROL_LIMIT: 'New Trade Control Limit',
  TC_EDIT_TRADE_CONTROL_LIMIT: 'Edit Trade Control Limit',
  TC_PROMPT_DELETE_TRADE_CONTROL_LIMIT: 'Delete {count, plural, =1 {Trade Control Limit} other {Trade Control Limits}}',
  SC_PROMPT_MSG_DELETE_SINGLE_TRADE_CONTROL_LIMIT: 'Are you sure you want to delete trade control limit for organisation "{name}"?',
  SC_PROMPT_MSG_DELETE_MULTI_TRADE_CONTROL_LIMIT: 'Are you sure you want to delete {count} trade control limits?',

  // Deal Download Dialog
  TC_DEAL_DOWNLOAD_TITLE: 'Download Trades',
  TC_CSV_DEAL_DOWNLOAD: 'CSV',
  TC_CONTINGENCY_DEAL_DOWNLOAD: 'Contingency File',
  SC_DEAL_DOWNLOAD_DOWNLOAD_TYPE: 'Select download type',
  SC_DEAL_DOWNLOAD_CCP: 'Select CCP',

  // Product Dialog
  TC_NEW_PRODUCT: 'New Product',
  TC_EDIT_PRODUCT: 'Edit Product',

  // Sector Dialog
  TC_NEW_SECTOR: 'New Sector',
  TC_EDIT_SECTOR: 'Edit Sector',
  TC_VIEW_SECTOR: 'View Sector',
  SC_IS_EX_DIVIDEND: 'Do collaterals trade ex-dividends?',
  TC_REFERENCE_RATE_DEFAULT_CRYSTALLISATION: 'Default Float Crystallisation (Days)',

  // Dialogs
  TC_TREAT_AS_CURVE: 'Treat as Curve',
  SC_TREAT_AS_CURVE_CONFIRMATION:
    'This OCO collection is within the 3% start consideration threshold, would you like to treat it as a Curve?',
  TC_CANCEL_RFQ: 'Cancel Selected RFQ',
  SC_CANCEL_RFQ_CONFIRMATION: 'Are you sure you would like to cancel the selected RFQ?',
  TC_CANCEL_ROW_RFQ: 'Cancel RFQ',
  SC_CANCEL_ROW_RFQ_CONFIRMATION: 'Are you sure you want to cancel this RFQ?',
  TC_CANCEL_ALL_RFQ: 'Cancel All RFQs',
  SC_CANCEL_ALL_RFQ_CONFIRMATION_1: 'CAUTION:',
  SC_CANCEL_ALL_RFQ_CONFIRMATION_2: 'This action will cancel all displayed RFQs initiated by your TRADING ENTITY.',
  SC_CANCEL_ALL_RFQ_CONFIRMATION_3: 'Are you sure you would like to proceed?',
  TC_CANCEL_DEAL: 'Cancel Selected Trade',
  TC_STOP_AMEND_DEAL: 'Stop Amending Selected Trade',
  TC_FORCE_STOP_AMEND_DEAL: 'Force Stop Amending Trade',
  TC_AMEND_DEAL: 'Amend Selected Trade',
  TC_RETRY_DEAL: 'Retry Selected Trade',
  TC_COMPLETE_DEAL: 'Complete Selected Trade',
  SC_CANCEL_DEAL_CONFIRMATION: 'Are you sure you would like to cancel the selected trade?',
  SC_AMEND_DEAL_CONFIRMATION: 'Are you sure you would like to amend the selected trade?',
  SC_RETRY_DEAL_CONFIRMATION: 'Are you sure you would like to retry the selected trade?',
  SC_COMPLETE_DEAL_CONFIRMATION: 'Are you sure you would like to complete the selected trade?',
  TC_DELETE_HAIRCUT_ENTRY: 'Delete Haircut Entry',
  SC_DELETE_HAIRCUT_ENTRY_CONFIRMATION: 'Are you sure you would like to delete this haircut entry?',
  TC_DELETE_HAIRCUT_ENTRIES: 'Delete Haircut Entries',
  SC_DELETE_HAIRCUT_ENTRIES_CONFIRMATION: 'Are you sure you would like to delete these haircut entries?',
  TC_RESTORE_DEFAULT_LAYOUT: 'Restore Default Layout',
  SC_RESTORE_DEFAULT_LAYOUT_CONFIRMATION: 'Are you sure you would like to restore the default layout?',
  SC_CLOSE_TICKET_WITH_AMENDMENTS: 'You have amendments which will be lost. Are you sure you would like to continue?',
  SC_FORCE_STOP_AMEND_TICKET:
    'This ticket is currently being amended by another user, do you wish to force stop amending? All their changes will be lost.',
  SC_DUPLICATE_ISIN_CONFIRMATION: 'This ISIN already exists in BTQ, are you sure you want to proceed?',
  SC_ISIN_LENGTH_ERROR: 'Must be 12 characters long',
  SC_CANNOT_MIX_RFQ_TYPE: 'Invalid package leg RFQ type',
  SC_COLLECTION_NAME_ALREADY_EXISTS: 'Collection name already exists',
  SC_CANNOT_MIX_RFQ_TYPE_MESSAGE: `AON packages cannot contain firm and indicative RFQs. You are adding an RFQ of type {orderRFQTye}. The AON package "{packageName}" contains only {packageRfqType} RFQs.
  Would you like to convert all RFQs in package "{packageName}" to Indicative or Firm?`,
  SC_FORCE_ADD_TO_EXISTING_COLLECTION:
    'Collection name "{collectionName}" already exists for a Standard collection, do you want to use the existing collection name?',
  TC_CANCEL_RFQS: 'You are about to cancel this RFQ(s) for all counterparties, are you sure you want to continue?',
  TC_BULK_PRICE: 'Bulk Price',
  SC_BULK_PRICE_CONFIRMATION: 'This will overwrite any currently values in the selected rows. Are you sure you want to continue?',
  TC_BULK_DATE: 'Bulk Date',
  SC_BULK_DATE_UPDATE_CONFIRMATION:
    'You are about to overwrite the existing values for one or more selected rows, do you want to continue?',
  TC_BULK_APPLY_SALES_COVER: 'Bulk Apply Sales Cover',
  SC_BULK_APPLY_SALES_COVER_CONFIRMATION:
    'This will update all the selected rows with the primary and secondary sales cover shown. Do you wish to continue?',
  TC_BULK_APPLY_TRADING_ENTITY_DEFAULTS: 'Bulk Apply Trading Entity Defaults',
  SC_BULK_APPLY_TRADING_ENTITY_DEFAULTS_CONFIRMATION:
    'This will update all the selected rows with the values selected. Do you wish to continue?',
  TC_DELETE_SPLIT_TRADE_ENTRY: 'Delete Split Trade Entry',
  SC_DELETE_SPLIT_TRADE_ENTRY_CONFIRMATION: 'Are you sure you would like to delete this split trade entry?',
  TC_DELETE_SPLIT_TRADE_ENTRIES: 'Delete Split Trade Entries',
  SC_DELETE_SPLIT_TRADE_ENTRIES_CONFIRMATION: 'Are you sure you would like to delete these split trade entries?',
  TC_DELETE_SALES_COVERAGE_ENTRY: 'Delete Sales Coverage Entry',
  SC_DELETE_SALES_COVERAGE_ENTRY_CONFIRMATION: 'Are you sure you would like to delete this sales coverage entry?',
  TC_DELETE_SALES_COVERAGE_ENTRIES: 'Delete Sales Coverage Entries',
  SC_DELETE_SALES_COVERAGE_ENTRIES_CONFIRMATION: 'Are you sure you would like to delete these sales coverage entries?',
  TC_COLLATERAL_WILL_BE_SUSPENDED: 'Collateral Suspension',
  SC_ROLL_CONFIRMATION: 'This will Roll this trade and create a new order in staging. Do you wish to Continue?',
  TC_PERMISSIONS_REPORT: 'Permissions Report',
  TC_PURGE_ENTITY: 'Purge Entity',
  SC_PERMISSIONS_REPORT_SUCCESS: 'Permissions report generated successfully',
  SC_PURGE_ENTITY_SUCCESS: 'Entity Purged Successfully',
  SC_PERMISSIONS_REPORT_WARNING:
    'There are more than {maxItems} entities or users for this organisation. Running this report could have a performance impact. Are you sure you wish to continue?',
  TC_ISSUER_ID_TYPE: 'Issuer Id Type',

  // Button Captions
  TC_BUTTON_OK: 'OK',
  TC_BUTTON_CLOSE: 'Close',
  TC_BUTTON_CLOSE_TICKET: 'Close Ticket',
  TC_BUTTON_CANCEL: 'Cancel',
  TC_BUTTON_RETRY: 'Retry',
  TC_BUTTON_SEND_RFQ: 'Send',
  TC_BUTTON_SAVE: 'Save',
  TC_BUTTON_ASSIGN: 'Assign',
  TC_BUTTON_ALLOCATE_COLLATERAL: 'Allocate Collateral',
  TC_BUTTON_UPLOAD: 'Upload',
  TC_BUTTON_MTE_UPLOAD: 'Upload {count, plural, =1 {Mid Trade Event} other { # Mid Trade Events}}',
  TC_BUTTON_ADD: 'Add',
  TC_BUTTON_DELETE: 'Delete',
  TC_BUTTON_CREATE: 'Create',
  TC_BUTTON_CREATE_NEW: 'Create New',
  TC_BUTTON_UPDATE: 'Update',
  TC_BUTTON_YES: 'Yes',
  TC_BUTTON_NO: 'No',
  TC_BUTTON_DOWNLOAD: 'Download',
  TC_BUTTON_DOWNLOAD_LOGS: 'Download Logs',
  TC_BUTTON_CLOSE_APPLICATION: 'Close Application',
  TC_BUTTON_NEW_USER: 'Add User',
  TC_BUTTON_NEW_HAIRCUT: 'Add Haircut',
  TC_BUTTON_NEW_ORGANISATION: 'Add Organisation',
  TC_BUTTON_NEW_TRADING_ENTITY: 'Add Trading Entity',
  TC_BUTTON_NEW_COLLATERAL: 'Add Collateral',
  TC_BUTTON_NEW_FAT_FINGER_LIMIT: 'Add Fat Finger Limit',
  TC_BUTTON_NEW_HOLIDAY: 'Add Holiday',
  TC_BUTTON_NEW_INDEX: 'Add Index',
  TC_BUTTON_NEW_TRADE_CONTROL: 'Add Limit',
  TC_BUTTON_NEW_TRADE_SPLIT: 'Add Trade Split',
  TC_BUTTON_NEW_SALES_COVERAGE: 'Add Sales Coverage',
  TC_BUTTON_NEW_TRADING_ENTITY_ALIAS: 'Add Alias',
  TC_BUTTON_NEW_PRIME_BROKER: 'Add Prime Broker',
  SC_BUTTON_CLEAR_ALL: 'Clear all',
  TC_BUTTON_VIEW_TICKET: 'View Ticket',
  TC_BUTTON_SAVE_GROUP: 'Save Group',
  TC_REMOVE_ALL: 'Remove All',
  TC_BUTTON_CREATE_GROUP: 'Create Group',
  TC_BUTTON_AXE: 'Axe',
  TC_BUTTON_ROLL: 'Roll',
  TC_BUTTON_UNWIND: 'Unw',
  TC_BUTTON_SUB: 'Sub',
  TC_BUTTON_SEND_REQUEST: 'Send Request',
  TC_BUTTON_SEARCH: 'Search',
  TC_BUTTON_NEW_PRODUCT: 'Add Product',
  TC_BUTTON_NEW_SECTOR: 'Add Sector',
  TC_BUTTON_NEW_SECTOR_MAPPING: 'Add Sector mapping',
  TC_BUTTON_MAPPINGS_REPORT: 'Mappings Report',
  TC_BUTTON_COMMIT_MAPPINGS: 'Commit Mappings',
  TC_BUTTON_DISCARD_MAPPINGS: 'Discard Mappings',
  TC_BUTTON_APPLY: 'Apply',
  SC_BUTTON_YES_AND_STAGE: 'Yes and move to staging',
  TC_BUTTON_REFRESH: 'Refresh {count, plural, =1 {deal} other {(#) Deals}}',
  TC_ADD_ISSUER_ORGANISATION: 'Add Issuer Organisation',
  TC_EDIT_ISSUER_ORGANISATION: 'Edit Issuer Organisation',

  // Notifications
  TC_NOTIFICATION_CATEGORY: 'BrokerTec Quote',
  TC_NOTIFICATION_SUCCESS: 'Success',
  TC_NOTIFICATION_ERROR: 'Error',
  TC_NOTIFICATION_WARNING: 'Warning',

  SC_NOTIFICATION_UPLOAD_SUCCESS: 'Upload successful',
  SC_NOTIFICATION_RFQ_SEND_SUCCESS: 'RFQ sent',
  SC_NOTIFICATION_USER_PREFERENCE_UPDATE_SUCCESS: 'User preferences updated',
  SC_NOTIFICATION_RFQ_PLACED_SUCCESS: 'Basket order request sent to staging',
  SC_YOU_HAVE_RECEIVED_EVENTS: 'You have received {count, plural, =1 {1 {statusText} event} other {# {statusText} events}}',
  TC_VIEW_QUEUE: 'View Queue',

  // Connection Errors
  SC_CONNECTION_FAILED: 'Unable to connect to the server',
  SC_CONNECTION_FAILED_AFTER_RETRIES: 'Unable to connect to the server after {retries, plural, =1 {1 retry} other {# retries}}',
  SC_CONNECTING_TO: 'Connecting to {endpoint}',
  SC_CONNECTED_TO: 'Connected to {endpoint}',
  SC_DISCONNECTING_FROM: 'Disconnecting from {endpoint}',
  SC_DISCONNECTED_FROM: 'Disconnected from {endpoint}',
  SC_FAILED_TO_CONNECT_TO: 'Failed to connect to {endpoint}',

  // Application Errors
  SC_ERROR_CAUGHT: 'The application has encountered an error. Please contact support.',
  SC_LOGS_DOWNLOADED: 'Logs downloaded',
  SC_DATA_INTEGRITY_ERROR: 'The application has encountered a data integrity error. Please contact support.',

  // Collection
  SC_COLLECTION_EMPTY: 'This collection is empty',
  SC_COLLECTION_SUMMARY:
    '{totalQuotes, plural, =1 {1 quote} other {# quotes}} across {numFunds, plural, =1 {1 fund} other {# funds}}, {numBuys, plural, =1 {1 buy} other {# buys}}, {numSells, plural, =1 {1 sell} other {# sells}}, {status}',
  TC_ADD_TO_COLLECTION: 'Add to Collection',
  TC_EXISTING: 'Existing',
  TC_NEW: 'New',
  TC_COLLECTIONS: 'Collections',
  TC_COLLECTION_UNASSIGNED: 'No Collection',
  SC_ADD_TO_EXISTING_COLLECTION: 'Add to existing collection',
  SC_SELECT_COLLECTION: 'Enter/select collection',
  SC_SELECT_COLLECTION_TYPE: 'Select collection type',
  SC_NAME_COLLECTION: 'Write the name of the new collection',
  SC_UNIQUE_NAME: 'Type in a unique name',

  // Collateral Baskets
  TC_SINGLE_TRADES: 'Single Trades',

  TC_ADD_NEW_ASSETS: 'Add Assets',
  TC_ENTER_ASSET_DETAILS: 'Enter Asset Details',
  TC_FUND_LABEL: 'Fund/Entity',
  SC_FUND_PLACEHOLDER: 'Select a fund/entity',
  TC_COLLATERAL_LABEL: 'Collateral',
  SC_COLLATERAL_PLACEHOLDER: 'Select collateral',
  TC_INSTRUMENT_LABEL: 'Collateral/Collateral Basket',
  SC_INSTRUMENT_PLACEHOLDER: 'Select collateral/collateral basket',
  TC_NUMBER: 'Number',
  TC_STAGE_NEW_BASKET_ORDER: 'Stage New Basket Order - {basketName}',

  // Fund Assignments
  TC_ASSIGNMENT_LOCKED: 'Assignment Locked',
  SC_ASSIGNMENT_LOCKED_TO_ANOTHER_USER: 'Another user is currently assigning this block trade. Would you like to override their session?',
  SC_NO_FUND_DETAILS: 'No block fund details available',
  SC_NOT_ASSIGNMENT_AUTHOR: 'You are not the author of this assignment',
  TC_REMAINING_ASSIGNMENT_TIME: 'Remaining Assignment Time',
  SC_AVAILABLE_TRADING_ENTITIES_TO_ALLOCATE: 'Available trading entities to assign',
  SC_SEARCH_TRADING_ENTITIES: 'Search for specific trading entities',
  SC_NO_TRADING_ENTITIES_FOUND: 'No trading entities found',
  SC_SELECT_ASSIGNMENTS: 'Please select trading entities from the left to start assigning.',
  TC_ASSIGNMENT_REQUIRED: 'Assignment Required{amountFormat, select, THOUSANDS { (K)} MILLIONS { (M)} other {}}',
  TC_AMOUNT_ASSIGNED: 'Amount Assigned{amountFormat, select, THOUSANDS { (K)} MILLIONS { (M)} other {}}',
  TC_REMAINING_ASSIGNMENT_REQUIRED: 'Remaining Assignment Required{amountFormat, select, THOUSANDS { (K)} MILLIONS { (M)} other {}}',
  TC_ASSIGNED_TRADING_ENTITIES: 'Assigned Trading Entities ({tradingEntityCount})',
  TC_TRADING_ENTITY: 'Trading Entity',
  TC_PROMPT_TITLE_OVER_ASSIGNMENT: 'Over Assignment',
  TC_PROMPT_TITLE_UNDER_ASSIGNMENT: 'Under Assignment',
  SC_PROMPT_MSG_ACCEPT_OVER_ASSIGNMENT: 'Your block fund is over allocated by {remainingAssignmentText}. Are you sure you want to proceed?',
  SC_PROMPT_MSG_ACCEPT_UNDER_ASSIGNMENT:
    'Your block fund is under allocated by {remainingAssignmentText}. Are you sure you want to proceed?',
  TC_TRADING_ENTITY_ASSIGN_UPLOAD_MAPPING_TITLE: 'Spreadsheet Upload Results',
  TC_TRADING_ENTITY_ASSIGN_UPLOAD_TITLE: 'Fund Assignment Upload',
  TC_TRADING_ENTITY_ASSIGN_UPLOAD_PENDING: 'Pending Fund Assignment Uploads',
  TC_TRADING_ENTITY_ASSIGN_UPLOAD_DOWNLOAD_SPREADSHEET: 'Download Fund Assignments XLS Template',
  TC_TRADING_ENTITY_ASSIGN_UPLOAD_TEMPLATE_FILENAME: 'FundAssignmentTemplate.xlsx',
  TC_TRADING_ENTITY_ASSIGN_UPLOAD_UPLOAD_BUTTON_LABEL: 'Upload',
  TC_TRADING_ENTITY_ASSIGN_UPLOAD_UPLOAD_DROPDOWN_LABEL: 'Upload Fund Assignments',

  SC_TRADING_ENTITY_ASSIGN_UPLOAD_ERROR_NARRATIVE: 'There were errors parsing the upload',
  SC_TRADING_ENTITY_ASSIGN_UPLOAD_ERROR_ENTITY_NOT_FOUND: 'Trading entity with short code `{entity}` was not found',
  SC_TRADING_ENTITY_ASSIGN_UPLOAD_SUCCESS:
    '{count, plural, =0 {No entity assignments were} =1 {1 entity assignment was} other {# entity assignments were}} loaded successfully',
  SC_TRADING_ENTITY_ASSIGN_UPLOAD_ERROR:
    '{count, plural, =0 {No entity assignments} =1 {1 entity assignment} other {# entity assignments}} contained {errorCount, plural, =0 {no errors} =1 {a single error} other {# separate errors}}',
  SC_TRADING_ENTITY_ASSIGN_UPLOAD_DUPLICATE: 'Duplicate shortcode found {shortCode}',
  SC_TRADING_ENTITY_ASSIGN_UPLOAD_NO_NOTIONAL_FOR_CASH_TRADED: 'Notional cannot be uploaded for cash traded deals',
  SC_TRADING_ENTITY_ASSIGN_UPLOAD_NO_SC_FOR_NOTIONAL_TRADED: 'Start Consideration cannot be uploaded for notional traded deals',

  // Collateral Allocations
  TC_ALLOCATION_REQUIRED: 'Allocation Required{amountFormat, select, THOUSANDS { (K)} MILLIONS { (M)} other {}}',
  TC_AMOUNT_ALLOCATED: 'Amount Allocated{amountFormat, select, THOUSANDS { (K)} MILLIONS { (M)} other {}}',
  TC_REMAINING_ALLOCATION_REQUIRED: 'Remaining Allocation Required{amountFormat, select, THOUSANDS { (K)} MILLIONS { (M)} other {}}',
  TC_ALLOCATED_PRODUCTS: 'Allocated Products ({productCount})',
  SC_AVAILABLE_PRODUCTS_TO_ALLOCATE: 'Available products to allocate',
  TC_ALLOCATION_LOCKED: 'Allocation Locked',
  SC_ALLOCATION_LOCKED_TO_ANOTHER_USER: 'Another user is currently allocating this basket. Would you like to override their session?',
  SC_NO_BASKET_DETAILS: 'No basket details available.',
  SC_NOT_ALLOCATION_AUTHOR: 'You are not the author of this allocation.',
  SC_SEARCH_COLLATERALS: 'Search for specific collaterals',
  SC_NO_COLLATERALS_FOUND: 'No collaterals found',
  SC_SELECT_ALLOCATIONS: 'Please select collaterals from the left to start allocating.',
  TC_REMAINING_ALLOCATION_TIME: 'Remaining Allocation Time',
  TC_PROMPT_TITLE_OVER_ALLOCATION: 'Over Allocation',
  TC_PROMPT_TITLE_UNDER_ALLOCATION: 'Under Allocation',
  SC_PROMPT_MSG_ACCEPT_OVER_ALLOCATION: 'Your basket is over allocated by {remainingAllocationText}.  Are you sure you want to proceed?',
  SC_PROMPT_MSG_ACCEPT_UNDER_ALLOCATION: 'Your basket is under allocated by {remainingAllocationText}.  Are you sure you want to proceed?',
  SC_ALLOCATION_SPREADSHEET_SUCCESS:
    '{count, plural, =0 {No allocations were} =1 {1 allocation was} other {# allocations were}} loaded successfully',
  SC_ALLOCATION_SPREADSHEET_ERROR:
    '{count, plural, =0 {No allocations} =1 {1 allocation} other {# allocations}} contained {errorCount, plural, =0 {no errors} =1 {a single error} other {# separate errors}}',
  TC_ALLOCATION_BUTTON_UPLOAD: 'Upload Allocations',
  TC_ALLOCATION_UPLOAD: 'Upload Collateral Allocations',
  TC_ALLOCATION_UPLOAD_PENDING: 'Collateral Allocation Uploads',
  TC_ALLOCATION_DOWNLOAD_SPREADSHEET: 'Download sample allocation xlsx',
  TC_ALLOCATION_DOWNLOAD_TEMPLATE_FILENAME: 'CollateralBasketAllocationTemplate.xlsx',

  SC_ERROR_CLIPBOARD_MIXED_TRADING_TYPE: 'Allocations cannot have a mixture of notional and start consideration trading types',
  SC_ERROR_CLIPBOARD_INVALID_ISIN: 'ISIN is not valid for the basket',
  SC_ERROR_CLIPBOARD_INVALID_HAIRCUT: 'Haircut is not valid',
  SC_ALLOCATION_UPLOAD_ERROR_ALL_IN_PRICE_CLASSIC_ONLY: 'All In Price can only be set for Classic Repo allocations',
  SC_ALLOCATION_UPLOAD_ERROR_NO_HAIRCUT_SBL: 'Haircut cannot be set for Stock Borrow Lending allocations',
  SC_ALLOCATION_UPLOAD_ERROR_NARRATIVE: 'Please correct the errors and try again',
  // Deal Servicing Substitution
  SC_CURRENT_COLLATERAL: 'Current collateral',
  SC_CURRENT_HAIRCUT: 'Current haircut',
  SC_CURRENT_HAIRCUT_TYPE: 'Current collateral/haircut',
  SC_CURRENT_RATE: 'Current rate',
  SC_NEW_COLLATERAL: 'New collateral',
  SC_NEW_HAIRCUT: 'New haircut',
  SC_NEW_HAIRCUT_TYPE: 'New collateral/haircut',
  SC_NEW_RATE: 'New rate',
  SC_EFFECTIVE_DATE: 'Effective date',
  SC_EFFECTIVE_DATE_TODAY_WARNING_MESSAGE: 'Default notification deadline time has passed for today',
  SC_EFFECTIVE_DATE_AFTER_MAX_EFFECTIVE_DATE_ERROR_MESSAGE: 'Effective date is after maximum allowed for this collateral',
  SC_EFFECTIVE_DATE_CHANGED_FROM_DEFAULT: 'Effective date changed from default notice period',
  SC_EFFECTIVE_DATE_INVALID: 'Effective date cannot be on a holiday or weekend',
  SC_COLLATERAL_UNCHANGED: 'Collateral has not been changed',
  TC_CURRENT_COLLATERAL: 'Current Collateral',
  TC_CURRENT_HAIRCUT: 'Current Haircut',
  TC_CURRENT_HAIRCUT_TYPE: 'Current Collateral/Haircut',
  TC_SUBSTITUTE: 'Substitute',
  TC_SUBSTITUTE_TRADE: 'Substitute Trade',
  SC_SUBSTITUTE_TRADE_CONFIRMATION: 'Are you sure you would like to substitute the selected trade',
  // Deal Servicing Rerate
  SC_ADJUST_ALL_RATES: 'Adjust all rates by',
  SC_UPDATE_ALL_RATES: 'Update all rates to',
  SC_BPS: 'bps',
  SC_OR_ENTER_MANUALLY: 'or enter them manually',
  TC_CALCULATE: 'Calculate',
  TC_CURRENT_RATE: 'Current Rate',
  TC_CURRENT_HAIRCUT_ABBREVIATED: 'Current HC',
  TC_NEW_HAIRCUT_ABBREVIATED: 'New HC',
  SC_OUT_OF_RANGE_HAIRCUT_ERROR_MESSAGE: 'Haircut value should be within threshold of 50%',
  TC_CURRENT_FEE: 'Current Fee',
  TC_NEW_FEE: 'New Fee',
  SC_RERATE_CONFIRM: 'Are you sure you would like to Re-Rate the selected trade(s)',
  TC_RERATE_TRADE: 'Re-Rate Trade(s)',

  // Deal Servicing Close/Open
  SC_NEGATIVE_NOTIONAL_ERROR_MESSAGE: 'Notional must be positive',
  SC_NOTIONAL_TICKET_SIZE_ERROR_MESSAGE: 'The notional [{notional}] is not a multiple of the ticket size [{ticketSize}]',
  SC_HAIRCUT_WITHOUT_HAIRCUT_TYPE_ERROR_MESSAGE: 'Haircut type is required when haircut is non-null',
  TC_NEW_SECONDARY_COLLATERAL: 'New Secondary Collateral',
  TC_NEW_STOCK_BORROW_LENDING_TYPE: 'New SBL Type',
  SC_CLOSE_OPEN_CONFIRMATION: 'Are you sure you would like to close/open the selected trade(s)',
  TC_CLOSE_OPEN_TRADE: 'Close/Open Selected Trade',

  // Deal Servicing Termination
  TC_TERMINATION_REQUEST: 'Termination Request',
  TC_TERMINATE_TRADE: 'Terminate Selected Trade',
  SC_TERMINATE_TRADE_CONFIRMATION: 'Are you sure you would like to terminate the selected trade(s)',
  SC_REQUEST_INITIATED_AFTER_CUT_OFF_TIME: 'Request initiated after cut off time',
  SC_REQUEST_HAS_NO_ROE: 'Exit was not agreed on one or more trades',
  SC_REQUEST_HAS_NO_ROS: 'Substitution was not agreed on trade',
  SC_SET_ALL_EFFECTIVE_DATES: 'Set all effective dates to',
  TC_EVERGREEN_NOTICE_PERIOD_INFO_MESSAGE: 'Evergreen Notice Period: {evergreenNoticePeriod} days',

  // Deal Servicing Roll In Place
  SC_START_DATE: 'Start date',
  SC_NOTIONAL: 'Notional{amountFormat, select, THOUSANDS { (K)} MILLIONS { (M)} other {}}',
  SC_START_CONSIDERATION: 'Start consideration',
  SC_RATE: 'Rate',
  SC_HAIRCUT: 'Haircut',
  SC_HAIRCUT_TYPE: 'Haircut type',

  // Deal Servicing Trade Amend
  SC_REQUEST_INITIATED_AFTER_MARKET_CLOSE: 'Request initiated after market close',

  // Deal Servicing General
  SC_DECISION_MAKER_NOT_ACTIVE_ERROR_MESSAGE: 'Decision maker not an active user',

  // --------------------------
  // grids & blotters
  // --------------------------
  // toolbar and controls
  TC_COLUMNS: 'Columns',
  SC_SHOW_DELTAS: 'Show all deltas',
  TC_HIDE_EXPIRED_REJECTED: 'Hide Exp/Rej',
  TC_INCLUDE_TERMINATED: 'Include Terminated',
  SC_GROUP_ITEMS: 'Group items',
  SC_DISPLAY_HIDE_COLUMNS: 'Display/hide columns',
  SC_FILTER_ROWS: 'Filter rows',
  SC_FILTER: 'Filter...',
  SC_EXPORT_ALL_ROWS: 'Export all rows to csv',
  SC_EXTRACT_REPORT: 'Extract report',
  SC_EXTRACT_REPORT_SUCCESS: 'Extract report generated successfully',
  SC_RESTORE_DEFAULT_LAYOUT: 'Restore default layout',
  SC_AUTO_FIT_COLUMNS: 'Auto fit columns',
  SC_SEARCH_ALL_FIELDS: 'Search all fields',
  SC_EXPAND_COLLAPSE_ROW: 'Expand/Collapse row',
  SC_EXPAND_COLLAPSE_ALL_ROWS: 'Expand/Collapse all rows',
  SC_SELECT_BY_STATUS: 'Select rows by status',
  TC_NO_DATA: 'No Data Available',
  TC_SHOW_CANCELLED_AXES: 'Show Cancelled',
  SC_SHOW_ORGANISATION_ACTIVITY: "Show my firm's activity",
  SC_SHOW_MY_SALES_RFQS: 'Show only my sales RFQs',
  SC_SHOW_MY_SALES_RFQS_TOOLTIP: 'Shows all the RFQs where the user is the primary sales cover or secondary sales cover',
  SC_SHOW_MATURED_COLLATERALS: 'Show matured',
  TC_GROUPING_UNGROUPED: 'Ungrouped',
  TC_GROUPING_BASKETS: 'Baskets',
  TC_GROUPING_COLLECTIONS: 'Collections',
  TC_GROUPING_COUNTERPARTY: 'Counterparty',
  TC_GROUPING_RFQ_ID: 'RFQ ID',
  TC_GROUPING_CUSTOM: 'Custom',
  TC_BEST_PRICE_CALCULATION: 'Best Price Comparison',
  TC_BEST_PRICE: 'Best Price',
  UC_WAS: 'WAS',
  TC_FILTER_OPEN: 'Open',
  TC_FILTER_TODAYS: "Today's",
  TC_FILTER_SEARCH: 'Search',
  SC_FILTER_SEARCH_BY: 'Search by:',
  SC_FILTER_TRADE_ID_EQUALS: 'Trade ID',
  SC_FILTER_AXE_ID_EQUALS: 'Axe ID',
  SC_FILTER_EXTERNAL_AXE_ID_EQUALS: 'External Axe ID',
  SC_FILTER_ISIN_BUI_CUSIP_EQUALS: 'ISIN/CUSIP',
  SC_FILTER_CUSIP_EQUALS: 'CUSIP',
  SC_FILTER_MY_ENTITY_EQUALS: 'My Entity',
  SC_FILTER_MY_FIRM_EQUALS: 'My Firm',
  SC_FILTER_COUNTERPARTY_EQUALS: 'Counterparty',
  SC_FILTER_COUNTERPARTY_FIRM_EQUALS: 'Counterparty Firm',
  SC_FILTER_RATE_FROM: 'Rate From',
  SC_FILTER_RATE_TO: 'Rate To',
  SC_FILTER_CURRENCY_EQUALS: 'Currency',
  SC_FILTER_TERM_EQUALS: 'Term',
  SC_FILTER_DIRECTION_EQUALS: 'Direction',
  SC_FILTER_PRODUCT_EQUALS: 'Product',
  SC_FILTER_SECTOR_EQUALS: 'Sector',
  SC_FILTER_MY_TRADER_EQUALS: 'My Trader',
  SC_FILTER_COUNTERPARTY_TRADER_EQUALS: 'Counterparty Trader',
  SC_FILTER_COLLECTION_NAME_EQUALS: 'Collection Name',
  SC_FILTER_RATE_EQUALS: 'Rate',
  SC_FILTER_TRADE_DATE_AFTER: 'Trade date after',
  TC_FILTER_TRADE_DATE: 'Trade Date',
  SC_FILTER_AXE_AFTER: 'Axe date after',
  SC_FILTER_CREATED_AFTER: 'Created after',
  TC_FILTER_CREATED: 'Created',
  SC_FILTER_START_DATE_AFTER: 'Start date after',
  SC_FILTER_END_DATE_AFTER: 'End date after',
  SC_FILTER_AND_OR_BEFORE: 'and/or before',
  SC_FILTER_AXE_CREATED_AND_OR_BEFORE: 'and/or Axe Created Date Before',
  SC_FILTER_INVALID_TRADE_DATE_RANGE: 'Trade date before cannot be earlier than trade date after',
  SC_FILTER_INVALID_CREATED_AT_DATE_RANGE: 'Created before cannot be earlier than created after',
  SC_FILTER_INVALID_START_DATE_RANGE: 'Start date before cannot be earlier than start date after',
  SC_FILTER_INVALID_END_DATE_RANGE: 'End date before cannot be earlier than end date after',
  SC_FILTER_INVALID_DATE_RANGE: 'Date before cannot be earlier than date after',
  SC_FILTER_SECOND_DATE_MISSING: 'Please enter a second date',
  SC_SELECT_COLUMNS_TO_COPY: 'Select columns to copy',
  SC_COPY_SELECTED_COLUMNS: 'Copy selected columns and rows',
  SC_SHOW_ONLY_ENABLED_USERS: 'Show Enabled Only',
  TC_BULK_DATE_UPDATE_TERM: 'Or Term',

  // columns
  TC_GROUPING: 'Grouping',
  TC_EMPTY_HEADER: '',
  TC_COLLECTION_NAME: 'Collection Name',
  TC_COLLECTION_TYPE: 'Collection Type',
  TC_COLLECTION_ID: 'Collection ID',
  TC_CONTAINER_COLLECTION_ID: 'AONX ID',
  TC_PREV_RATE: 'Prev Rate',
  TC_CONTAINER_COLLECTION_NAME: 'AONX Name',
  TC_CURVE: 'Curve',
  TC_CLEARING_VENUE: 'Clearing Venue',
  TC_COUNTERPARTY_CLEARED: 'Cleared',
  TC_COUNTERPARTY_SPONSOR: 'Sponsoring Bank',
  TC_COUNTERPARTY: 'Counterparty',
  TC_EXECUTING_COUNTERPARTY: 'Executing Counterparty',
  TC_EXECUTING_COUNTERPARTY_SPONSOR: 'Executing Counterparty Sponsor',
  TC_EXECUTING_COUNTERPARTY_SPONSOR_SHORT: 'Ex. Counterparty Sponsor',
  TC_COUNTERPARTY_LEI: 'Counterparty LEI',
  TC_STATUS: 'Status',
  TC_OTW: 'OTW',
  TC_OTW_TIME: 'OTW Time',
  TC_RFQ: 'RFQ',
  TC_RFQ_TIME: 'RFQ Time',
  TC_DIRECTION: 'Direction',
  TC_ABBREVIATED_DIRECTION: 'Dir.',
  TC_ISIN: 'ISIN',
  TC_ISIN_CUSIP: 'ISIN/CUSIP',
  TC_ISIN_CUSIP_BUI: 'ISIN/CUSIP/BUI',
  TC_ISIN_BUI: 'ISIN/BUI',
  TC_NEW_ISIN_BUI: 'New ISIN/BUI',
  TC_SECONDARY_ISIN_BUI: 'Secondary ISIN/BUI',
  TC_BUI: 'BUI',
  TC_CUSIP: 'CUSIP',
  TC_COLLATERAL: 'Collateral',
  TC_COLLATERAL_ID: 'Collateral ID',
  TC_STOCK_BORROW_LENDING_TYPE: 'SBL Type',
  TC_NEW_COLLATERAL: 'New Collateral',
  TC_NEW_CUSIP: 'New CUSIP',
  TC_ALLOCATION_TIME: 'Allocation Time',
  TC_CURRENCY: 'Currency',
  TC_NOT_CURRENCY: 'Not Currency',
  TC_CCY: 'CCY',
  TC_REFERENCE_RATE: 'Reference Rate',
  TC_FLOAT_CRYSTALLISATION_DAYS: 'Float Crystallisation Days',
  TC_REFERENCE_RATES: 'Reference Rates',
  TC_BILLING_CURRENCY: 'Billing Currency',
  TC_PRIMARY_BILLING_CURRENCY: 'Primary Billing Currency',
  TC_SECONDARY_BILLING_CURRENCY: 'Secondary Billing Currency',
  TC_EX_DIVIDEND_DAY_CONVENTION: 'Ex Dividend Day Convention',
  TC_NOTIONAL: 'Notional{amountFormat, select, THOUSANDS { (K)} MILLIONS { (M)} other {}}',
  TC_MULTIPLE_NOTIONAL: 'Notional',
  TC_NEW_NOTIONAL: 'New Notional{amountFormat, select, THOUSANDS { (K)} MILLIONS { (M)} other {}}',
  TC_NEW_NOTIONAL_SHORT: 'New Notional',
  TC_NOTIONAL_SHORT: 'Notional',
  TC_ORIGINAL: 'Original{amountFormat, select, THOUSANDS { (K)} MILLIONS { (M)} other {}}',
  TC_ORIGINAL_SHORT: 'Original',
  TC_START_DATE: 'Start Date',
  TC_NEW_START_DATE: 'New Start Date',
  TC_END_DATE: 'End Date',
  TC_NEW_END_DATE: 'New End Date',
  TC_EFFECTIVE_DATE: 'Effective Date',
  TC_HAIRCUT: 'Haircut',
  TC_BID_HAIRCUT: 'Bid Haircut',
  TC_OFFER_HAIRCUT: 'Offer Haircut',
  TC_NEW_HAIRCUT: 'New Haircut',
  TC_HAIRCUT_TYPE: 'Collateral/Haircut',
  TC_NEW_HAIRCUT_TYPE: 'New Collateral/Haircut',
  TC_ACTIONS: 'Actions',
  TC_RATE: 'Rate',
  TC_NEW_RATE: 'New Rate',
  TC_RATE_VS_REFERENCE_RATE: 'Rate {referenceRate, select, null {} other {vs {referenceRate}}}',
  TC_LAST_QUOTED: 'Last Quoted',
  TC_ENTITY: 'Entity',
  TC_MY_ENTITY: 'My Entity',
  TC_MY_ENTITY_LEI: 'My Entity LEI',
  TC_MY_ENTITY_BIC: 'My Entity BIC',
  TC_MY_ENTITY_ID: 'My Entity Id',
  TC_MY_FIRM: 'My Firm',
  TC_MY_FIRM_LEI: 'My Firm LEI',
  TC_MY_INVESTMENT_DECISION_MAKER: 'My Investment Decision Maker',
  TC_MY_EXECUTION_DECISION_MAKER: 'My Execution Decision Maker',
  TC_SECTOR: 'Sector',
  TC_HAIRCUT_COLLATERAL_BAND: 'Maturity',
  TC_HAIRCUT_COLLATERAL_BAND_MIN: 'Min Coll Maturity >= Y',
  TC_HAIRCUT_COLLATERAL_BAND_MAX: 'Max Coll Maturity < Y',
  TC_HAIRCUT_ALL_VALUES: 'All',
  TC_TERM: 'Term',
  TC_EVERGREEN_NOTICE_PERIOD: 'Evergreen Notice Period',
  TC_NEW_TERM: 'New Term',
  TC_CREATION_TIMESTAMP: 'Creation Timestamp',
  TC_CREATION_TIME: 'Creation Time',
  TC_CREATION_DATE: 'Creation Date',
  TC_SUBMITTING_USER: 'Submitting User',
  TC_TARGET: 'Target',
  TC_DELTA: 'Delta',
  TC_COMPETITION: 'Competition',
  TC_COUPON: 'Coupon',
  TC_BOOK: 'Book',
  TC_NOTE: 'Note {noteIndex}',
  TC_STRATEGY: 'Strategy',
  TC_PRIME_BROKER: 'Prime Broker',
  TC_BUNDLE: 'Bundle',
  TC_ISSUER: 'Issuer',
  TC_UPLOAD_ROW_INDEX: 'Upload Row Index',
  TC_REPO_TYPE: 'Repo Type',
  TC_NEW_REPO_TYPE: 'New Repo Type',
  TC_CALLABLE: 'Callable',
  TC_NOTICE_PERIOD_DAYS: 'Notice Period (Days)',
  TC_DEFAULT_NOTICE_TIME: 'Default Notice Time',
  TC_DEFAULT_NOTICE_PERIOD: 'Default Notice Period (Days)',
  TC_EX_DIVIDEND_DAYS: 'Ex Dividend Days',
  TC_DEFAULT_REPO_TYPE: 'Default Repo Type',
  TC_SUPPORT_REPO_TYPES: 'Supported Repo Types',
  TC_CALL_DAYS: 'Call Days',
  TC_COLLATERAL_PRICE: 'Collateral Price',
  TC_NEW_COLLATERAL_PRICE: 'New Collateral Price',
  TC_NEW_FACTOR: 'New Factor',
  TC_ABBR_COLLATERAL_PRICE: 'Coll. Price',
  TC_ALL_IN_PRICE: 'All in Price',
  TC_INDEX_RATIO: 'Index Ratio',
  TC_ABBR_ALL_IN_PRICE: 'AIP',
  TC_COLLATERAL_ACCRUED_INTEREST: 'Collateral Accrued Interest',
  TC_REPO_INTEREST: 'Repo Int.',
  TC_PREVIOUS_REPO_INTEREST: 'Previous Repo Interest',
  TC_NEW_REPO_INTEREST: 'New Repo Int.',
  TC_ABBR_COLLATERAL_ACCRUED_INTEREST: 'Accr. Int.',
  TC_START_CONSIDERATION: 'Start Consideration',
  TC_ABSOLUTE_CONSIDERATION: 'Absolute Consideration',
  TC_NEW_START_CONSIDERATION: 'New Start Consideration',
  TC_END_CONSIDERATION: 'End Consideration',
  TC_NEW_END_CONSIDERATION: 'New End Consideration',
  TC_ABBR_START_CONSIDERATION: 'Start Cons.',
  TC_ABBR_START_CONSIDERATION_OVERRIDE: 'SC Overr.',
  TC_ABBR_END_CONSIDERATION: 'End Cons.',
  TC_PRODUCT: 'Product',
  TC_PRODUCT_NAME: 'Product Name',
  TC_SECTOR_NAME: 'Sector Name',
  TC_SECTOR_STATUS: 'Sector Status',
  TC_MARKET: 'Market',
  TC_MARKET_TYPE: 'Market Type',
  TC_PRIMARY: 'Primary',
  TC_SECONDARY: 'Secondary',
  TC_PRIMARY_MARKET: 'Primary market',
  TC_SECONDARY_MARKET: 'Secondary Market',
  TC_CREATED_BY: 'Created By',
  TC_LAST_UPDATED_BY: 'Last Updated By',
  TC_LAST_UPDATED_AT: 'Last Updated',
  TC_LAST_UPDATED_AT_DATE: 'Last Updated Date',
  TC_LAST_UPDATED_AT_TIME: 'Last Updated Time',
  TC_LAST_UPDATED_AT_DATE_AND_TIME: 'Last Updated Date/Time',
  TC_LAST_INITIATOR: 'Last Initiator',
  TC_LAST_RESPONDER: 'Last Responder',
  TC_ORIGINATOR: 'Originator',
  TC_POSITION_ID: 'Position Id',
  TC_AXE_ROLL_UNWIND: 'Axe/Roll/Unwind/Sub',
  TC_AXE_ROLL_UNWIND_SUMMARY: 'Axe/Roll/Unwind/Sub Summary',
  TC_ROLL_UNWIND: 'Roll/Unwind',
  TC_ROLL: 'Roll',
  TC_SUB: 'Sub',
  TC_UNWIND: 'Unwind',
  TC_AXE: 'Axe',
  TC_COUNTERPARTY_BIC: 'Counterparty BIC',
  TC_COUNTERPARTY_TRADER: 'Counterparty Trader',
  TC_COUNTERPARTY_FIRM: 'Counterparty Firm',
  TC_COUNTERPARTY_FIRM_LEI: 'Counterparty Firm LEI',
  TC_COUNTERPARTY_INVESTMENT_DECISION_MAKER: 'Ctpy Investment Decision Maker',
  TC_COUNTERPARTY_EXECUTION_DECISION_MAKER: 'Ctpy Execution Decision Maker',
  TC_DEAL_ID: 'Trade ID',
  TC_BLOCK_TRADE_ID: 'Block Trade ID',
  TC_PARENT_DEAL_ID: 'Parent Trade ID',
  TC_CHILD_DEAL_ID: 'Child Trade ID',
  TC_ORIGINAL_DEAL_ID: 'Original Trade ID',
  TC_NEGOTIATION_ID: 'Negotiation ID',
  TC_RFQ_ID: 'RFQ ID',
  TC_UTI: 'UTI/RTN',
  TC_LEI: 'LEI',
  TC_BIC: 'BIC',
  TC_MIC: 'MIC',
  TC_PRIMARY_MIC: 'Primary MIC',
  TC_SECONDARY_MIC: 'Secondary MIC',
  TC_TRADER: 'Trader',
  TC_DEAL_TIME: 'Trade Time',
  TC_DEAL_DATE: 'Trade Date',
  TC_DEAL_TIMESTAMP: 'Trade Timestamp',
  TC_MASTER_LEGAL_AGREEMENT: 'Master Legal Agreement',
  TC_PRIMARY_SALES_COVER: 'Primary Sales Cover',
  TC_SECONDARY_SALES_COVER: 'Secondary Sales Cover',
  TC_TRADING_ACTIVE: 'Trading Active',
  TC_LOGGED_IN: 'Logged In',
  TC_USER_NAME: 'User Name',
  TC_FIRST_NAME: 'First Name',
  TC_LAST_NAME: 'Last Name',
  TC_ORGANISATION: 'Organisation',
  TC_ORGANISATION_SHORT_CODE: 'Organisation Short Code',
  TC_LEGAL_NAME: 'Legal Name',
  TC_SHORT_ID: 'Short ID',
  TC_ORGANISATION_TYPES: 'Organisation Types',
  TC_EMAIL_ENABLED: 'Email Enabled',
  TC_EMAIL: 'Email',
  TC_SFTP_ENABLED: 'SFTP Enabled',
  TC_PHONE_NUMBER: 'Contact Number',
  TC_HAIRCUT_BAND_GREATER_THAN: `{days, plural, =0 {> 0 Days} =1 {> 1 Day} other {> # Days}} (%)`,
  TC_HAIRCUT_BAND_UNIQUE: `{days, plural, =0 {0 Days} =1 {1 Day} other {# Days}} (%)`,
  TC_HAIRCUT_BAND_RANGE: `{minDays} - {maxDays} Days (%)`,
  TC_HAIRCUT_COLLATERAL_BAND_LESS_THAN: `{years, plural, =1 {< 1 Year} other {< # Years}}`,
  TC_HAIRCUT_COLLATERAL_BAND_GREATER_THAN: `{years, plural, =1 {> 1 Year} other {> # Years}}`,
  TC_HAIRCUT_COLLATERAL_BAND_RANGE: `{minYears} - {maxYears} Years`,
  TC_COUNTRY: 'Country',
  TC_FIRST_SETTLEMENT_DATE: 'First Settlement Date',
  TC_DIRTY_PRICE: 'Dirty Price',
  TC_CLEAN_PRICE: 'Clean Price',
  TC_CLEAN_PRICE_UPDATED: 'Price Updated',
  TC_TICKET_SIZE: 'Ticket Size',
  TC_BASIS_CONVENTION: 'Basis Convention',
  TC_ACCRUED_INTEREST_DATE: 'Accrual Date',
  TC_FIRST_COUPON_DATE: 'First Coupon Date',
  TC_MATURITY_DATE: 'Maturity Date',
  TC_FREQUENCY: 'Frequency',
  TC_COUPON_TYPE: 'Coupon Type',
  TC_FIXED_RATE_PRICE: 'Fixed Rate Price (%)',
  TC_FIXED_RATE_WARN_LEVEL: 'Fixed Rate Warn Level (BP)',
  TC_FIXED_RATE_RESTRICTION: 'Fixed Rate Restriction (BP)',
  TC_FLOAT_RATE_SPREAD: 'Float Rate Spread (BP)',
  TC_FLOAT_RATE_WARN_LEVEL: 'Float Rate Warn Level (BP)',
  TC_FLOAT_RATE_RESTRICTION: 'Float Rate Restriction (BP)',
  TC_NOTIONAL_AMOUNT_WARN: 'Notional Amount Warn (M)',
  TC_NOTIONAL_AMOUNT_RESTRICTION: 'Notional Amount Restriction (M)',
  TC_CASH_AMOUNT_WARN: 'Cash Amount Warn (M)',
  TC_CASH_AMOUNT_RESTRICTION: 'Cash Amount Restriction (M)',
  TC_HOLIDAY: 'Holiday',
  TC_ALIAS: 'Alias',
  TC_BASKET_ID: 'Basket Id',
  TC_BASKET_NAME: 'Basket Name',
  TC_BASKET_TYPE: 'Basket Type',
  TC_BASKET_CURRENCY: 'Basket Currency',
  TC_BASKET_DESCRIPTION: 'Description',
  TC_BASKET_CME_BASKET_REFERENCE: 'CME Basket Reference',
  TC_BASKET_DEAL_ID: 'Basket Trade Id',
  TC_MINIMUM_CONCENTRATION_LEVEL: 'Min. Concentration Level',
  TC_MAXIMUM_CONCENTRATION_LEVEL: 'Max. Concentration Level',
  TC_MINIMUM_AMOUNT: 'Minimum Amount',
  TC_SUBSTITUTION_ALLOWED: 'Substitution Allowed',
  TC_SUBSTITUTION_NUM: 'No. of Substitutions',
  TC_CALCULATE_ACCRUED_INTEREST: 'Calculate Accrued Interest',
  TC_TO_DATE: 'To Date',
  TC_FROM_DATE: 'From Date',
  TC_DBV_CLASS: 'DBV Class',
  TC_INDEX_DESCRIPTION: 'Description',
  TC_BLOOMBERG_CODE: 'Bloomberg Code',
  TC_VALID_FOR: 'Valid For',
  TC_PRICE: 'Price',
  TC_INVESTMENT_DECISION_MAKER: 'Investment Decision Maker',
  TC_EXECUTION_DECISION_MAKER: 'Execution Decision Maker',
  TC_INVESTMENT_DECISION_MAKER_ABBR: 'IDM',
  TC_EXECUTION_DECISION_MAKER_ABBR: 'EDM',
  TC_BEST_QUOTE_RECEIVED: 'Best Quote Received',
  TC_TRADE_TYPE: 'Trade Type',
  TC_EVENT_TYPE: 'Event Type',
  TC_LIMIT: 'Limit{amountFormat, select, THOUSANDS { (K)} MILLIONS { (M)} other {}}',
  TC_UTILISATION: 'Utilisation{amountFormat, select, THOUSANDS { (K)} MILLIONS { (M)} other {}}',
  TC_AVAILABLE: 'Available{amountFormat, select, THOUSANDS { (K)} MILLIONS { (M)} other {}}',
  TC_PRIMARY_COVER: 'Primary Sales Cover',
  TC_SECONDARY_COVER: 'Secondary Sales Cover',
  TC_ACTION: 'Action',
  TC_RESPONSE: 'Response',
  TC_RFQ_TYPE: 'RFQ Type',
  TC_TRADING: 'Trading',
  TC_PLATFORM: 'Platform',
  TC_FISN: 'FISN',
  TC_CFI: 'CFI',
  TC_ACCRUAL_DATE: 'Accrual Date',
  TC_COLLATERAL_TYPE: 'Collateral Type',
  TC_INDEX: 'Index',
  TC_INDEX_LAG: 'Lag',
  TC_BASE_INDEX_VALUE: 'Base Index Value',
  TC_ALLOW_PARTIAL: 'Allow Partial',
  TC_TOTAL_FILL_NOTIONAL: 'Total Fill Notional',
  TC_TARGET_FILL_NOTIONAL: 'Target Fill Notional',
  TC_TOTAL_FILL_START_CONSIDERATION: 'Total Fill Start Consideration',
  TC_TARGET_FILL_START_CONSIDERATION: 'Target Fill Start Consideration',
  TC_PRE_AGREED: 'Pre Agreed',
  TC_PERMISSION: 'Permission',
  TC_RELATIONSHIP_ACTION: 'Action',
  TC_BUY_ORGANISATION: 'Buy Side Organisation',
  TC_BUY_TRADING_ENTITY: 'Buy Side Trading Entity',
  TC_SELL_ORGANISATION: 'Sell Side Organisation',
  TC_SELL_TRADING_ENTITY: 'Sell Side Trading Entity',
  TC_US_SC_ENABLED: 'US Sponsored Clearing',
  TC_US_SC_DEFAULT: 'US SC Default',
  TC_CURRENCY_PAIR: 'Currency Pair',
  TC_FX_RATE: 'FX Rate',
  TC_DATE_TIME_UPDATED: 'Date/Time Updated',
  TC_ORGANISATION_META_ALL_VALUES: 'All',
  TC_SETTLEMENT_TYPE: 'Settlement Type',
  TC_EXTERNAL_NEGOTIATION_ID: 'FIX-QuoteReqID',
  TC_EXTERNAL_ORDER_ID: 'FIX-CloRdID',
  TC_ORDER_ID: 'FIX-OrderID',
  TC_EXTERNAL_QUOTE_ID: 'FIX-QuoteID',
  TC_EXTERNAL_QUOTE_RESPONSE_ID: 'FIX-QuoteRespID',
  TC_START_CONSIDERATION_OVERRIDE_THRESHOLD: 'Start Consideration Override Threshold',
  TC_START_CONSIDERATION_OVERRIDE: 'Start Consideration Overridden',
  TC_NEW_START_CONSIDERATION_OVERRIDE: 'New SC Overridden',
  TC_OKTA_STATUS: 'OKTA Status',
  TC_OKTA_LAST_LOGIN: 'Last Login Date/Time',
  TC_FEE: 'Fee',
  TC_MY_ENTITY_SHORT_NAME: 'My Entity Short Name',
  TC_MY_FICC_ENTITY_SHORT_NAME: 'My Entity FICC Short Name',
  TC_BATCH_ID: 'Batch ID',
  TC_LAG_AMOUNT: 'Lag Amount',
  TC_LAG_TYPE: 'Lag Type',
  TC_START_TIME: 'Trading Start Time',
  TC_PRIMARY_START_TIME: 'Primary Trading Start Time',
  TC_SECONDARY_START_TIME: 'Secondary Trading Start Time',
  TC_TIME_ZONE: 'Time Zone',
  TC_PRIMARY_TIME_ZONE: 'Primary Time Zone',
  TC_SECONDARY_TIME_ZONE: 'Secondary Time Zone',
  TC_TRADING_STATUS: 'Trading Status',
  TC_PRIMARY_TRADING_STATUS: 'Primary Trading Status',
  TC_SECONDARY_TRADING_STATUS: 'Secondary Trading Status',
  TC_ISSUER_ORG_NAME: 'Issuer Organisation Name',
  TC_ULTIMATE_PARENT_ORG_ID: 'Ultimate Parent Org Id',
  TC_ULTIMATE_PARENT_NAME: 'Ultimate Parent Name',
  TC_ULTIMATE_PARENT_LEI: 'Ultimate Parent LEI',
  TC_ULTIMATE_PARENT_PERM_ID: 'Ultimate Parent Perm Id',
  TC_TRADED_ON_US_EXCHANGE: 'Traded On US Exchange',
  TC_SANCTIONED_SCREENED: 'Sanctioned Screened',
  TC_COMPLIANCE_SUSPENDED: 'Compliance Suspended',
  TC_COMPLIANCE_EUROPE: 'EU Compliance Status',
  TC_MARKET_TRADE_DATE: 'Market Trade Date',
  TC_MARKET_MID_TRADE_DATE: 'Mid Trade Market Date',
  TC_TRADING_LIMIT: 'Limit',
  TC_GROSS_UTILISATION: 'Gross Utilisation',
  TC_GROSS_AVAILABLE: 'Gross Available',
  TC_NET_UTILISATION: 'Net Utilisation',
  TC_NET_AVAILABLE_BUY: 'Net Avail. Buy',
  TC_NET_AVAILABLE_SELL: 'Net Avail. Sell',
  TC_USER_LIMITS: 'User Limits',
  TC_FAT_FINGER_LIMITS: 'Fat Finger Limits',
  TC_TRADING_LIMIT_TYPE: 'Select Trading Limit Type',
  TC_APPLY_FAT_FINGER_LIMITS: 'Apply User Fat Finger Limits',
  TC_ADD_FAT_FINGER_LIMITS: 'Add Fat Finger Limits',
  // renderers
  // * Actions column renderer
  TC_ACTION_ADD_ASSETS: 'Add Assets',
  TC_ACTION_UPLOAD_SPREADSHEET: 'Upload XLS',
  TC_ACTION_UPLOAD_PRICES: 'Upload Prices',
  TC_ACTION_UPLOAD_EVENTS: 'Add Events',
  TC_ACTION_UPLOAD_RESPONSES: 'Add Responses',
  TC_ACTION_UPLOAD_TRADING_ENTITIES: 'Upload Trading Entities',
  TC_ACTION_UPLOAD_TRADING_ENTITY_PRODUCTS: 'Upload Trading Entity Products',
  TC_ACTION_UPLOAD_TRADING_RELATIONSHIPS: 'Update Trading Entity Relationships',
  TC_ACTION_DOWNLOAD_SPREADSHEET: 'Download XLS Template',
  TC_ACTION_DOWNLOAD_RESPONSE_SPREADSHEET: 'Download Response XLS Template',
  TC_ACTION_DOWNLOAD_TRADING_ENTITIES_SPREADSHEET: 'Download Trading Entities XLS Template',
  TC_ACTION_DOWNLOAD_TRADING_ENTITY_PRODUCTS_SPREADSHEET: 'Download Trading Entity Products XLS Template',
  TC_ACTION_DOWNLOAD_TRADING_RELATIONSHIPS_SPREADSHEET: 'Download Trading Entity Relationships XLS Template',
  TC_ACTION_PREPARE: 'Prepare',
  TC_ACTION_STOP_PREPARE: 'Stop Preparing',
  TC_ACTION_DELETE: 'Delete',
  TC_ACTION_CLONE: 'Clone',
  TC_ACTION_ASSIGN_COLLECTION: 'Add To Collection',
  TC_ACTION_REMOVE_COLLECTION: 'Remove From Collection',
  TC_ACTION_BULK_PRICE: 'Bulk Price',
  TC_ACTION_SEND: 'Send',
  TC_ACTION_SEND_QUOTE: 'Send Quote',
  TC_ACTION_COUNTER: 'Counter',
  TC_ACTION_UNDO: 'Undo',
  TC_ACTION_ACCEPT: 'Accept',
  TC_ACTION_ACCEPT_NEW: 'Accept (New)',
  TC_ACTION_ACCEPT_COUNTER: 'Accept (Cntr)',
  TC_ACTION_REJECT: 'Reject',
  TC_ACTION_ACCEPT_COUNTERPARTY: 'Accept {counterparty}',
  TC_ACTION_WITHDRAW: 'Withdraw',
  TC_ACTION_CANCEL_RFQ: 'Cancel RFQ',
  TC_ACTION_CANCEL_ALL: 'Cancel All',
  TC_ACTION_BACK_TO_STAGING: 'Move to Staging',
  TC_ACTION_BACK_TO_STAGING_ALL: 'Move All to Staging',
  TC_ACTION_CANCEL_TRADE: 'Cancel Trade',
  TC_ACTION_RETRY_TRADE: 'Retry',
  TC_ACTION_COMPLETE_TRADE: 'Complete',
  TC_ACTION_REFRESH: 'Refresh',
  TC_ACTION_OPEN_TICKET: 'Open Ticket',
  TC_ACTION_START_AMEND: 'Start Amend',
  TC_ACTION_STOP_AMEND: 'Stop Amend',
  TC_ACTION_FORCE_STOP_AMEND: 'Force Stop Amend',
  TC_ACTION_AMEND: 'Amend',
  TC_ACTION_AMEND_TRADE: 'Amend Trade',
  TC_ACTION_SUSPEND_TRADING: 'Suspend Trading',
  TC_ACTION_ACTIVATE_TRADING: 'Activate Trading',
  TC_ACTION_SUSPEND_TRADING_EU: 'Suspend Trading (EU)',
  TC_ACTION_ACTIVATE_TRADING_EU: 'Activate Trading (EU)',
  TC_ACTION_SUSPEND_TRADING_US: 'Suspend Trading (US)',
  TC_ACTION_ACTIVATE_TRADING_US: 'Activate Trading (US)',
  TC_ACTION_END_DAY_EU: ' End of Day (EU)',
  TC_ACTION_START_DAY_EU: 'Start of Day (EU)',
  TC_ACTION_START_DAY_EU_TOMORROW: 'Start of Day (EU T+1)',
  TC_ACTION_END_DAY_US: ' End of Day (US)',
  TC_ACTION_START_DAY_US: 'Start of Day (US)',
  TC_ACTION_PRE_START_DAY_US: 'Pre Open',
  TC_ACTION_VIEW_DETAILS: 'View Details',
  TC_ACTION_EDIT_DETAILS: 'Edit Details',
  TC_ACTION_EDIT: 'Edit',
  TC_ACTION_ORDER_RECORD_KEEPING_DUMP: 'Trigger ORK Dump',
  TC_ACTION_TRANSACTION_REPORTING_DUMP: 'Trigger TR Dump',
  TC_ACTION_REFINITIV_IMPORT_REPORT: 'Refinitiv import report',
  TC_ACTION_NEGOTIATION_EXPORT_DUMP: 'Trigger NE Dump',
  TC_ACTION_DEAL_EXPORT_DUMP: 'Trigger Deal Dump',
  TC_ACTION_PERMISSIONS_REPORT: 'Permissions Report',
  TC_ACTION_PURGE_ENTITY: 'Purge Entity',
  TC_ACTION_SOTW: 'Trigger SOTW',
  TC_ACTION_CALCULATE_END_CONSIDERATION: 'Calculate End Cash',
  TC_ACTION_COMPLETE_DEALS: 'Complete deals',
  TC_ACTION_FAILED_EXPORTS_RETRY: 'Retry Failed Exports',
  TC_ACTION_FAILED_EXPORTS_DELETE: 'Delete Failed Exports',
  TC_ACTION_ENABLE: 'Enable',
  TC_ACTION_DISABLE: 'Disable',
  TC_ACTION_SUSPEND: 'Suspend',
  TC_ACTION_ACTIVATE: 'Activate',
  TC_ACTION_OPEN_PROFILE: 'Open Profile',
  TC_ACTION_CLOSE_PROFILE: 'Close Profile',
  TC_ACTION_USER_PREFERENCES: 'User Preferences',
  TC_ACTION_ABOUT: 'About',
  TC_ACTION_LOGOUT: 'Sign Out',
  TC_ACTION_SIGN_OUT_USER: 'Sign Out User',
  TC_ACTION_SHOW_CLEARING_INFO: 'Show SWIFT Interaction',
  TC_ACTION_SEND_DIAGNOSTICS: 'Send Diagnostics Info',
  TC_ACTION_STAGE: 'Stage',
  TC_ACTION_ASSIGN: 'Assign',
  TC_ACTION_ALLOCATE_COLLATERAL: 'Allocate Collateral',
  TC_ACTION_EXTEND_ALLOCATION_TIME: 'Extend Alloc. Time',
  TC_ACTION_SUBSTITUTE: 'Substitute',
  TC_ACTION_RERATE: 'Rerate',
  TC_ACTION_CLOSE_OPEN: 'Close/Open',
  TC_ACTION_RETURN_RECALL: 'Return/Recall',
  TC_ACTION_TERMINATE: 'Terminate',
  TC_ACTION_ROLL_IN_PLACE: 'Roll In Place',
  TC_ACTION_CANCEL: 'Cancel',
  TC_ACTION_REJECT_TERMINATE: 'Terminate',
  TC_ACTION_REJECT_RERATE: 'Rerate',
  TC_ACTION_BULK_APPLY: 'Bulk Apply',
  TC_ACTION_UPDATE_FROM_RIFINITIV: 'Update From Refinitiv',
  SC_ACTION_NOT_BEST_PRICE: 'Best price not selected',
  SC_ACTION_PRICE_MATCHED: 'This price has been matched',
  TC_ACTION_TRADE_HISTORY: 'Trade History',
  SC_CANCEL_RFQS: 'Cancel RFQs',
  TC_VIEW_RELATED_TRADES: 'Trade History',
  TC_SPLIT_TRADES: 'Split Trades',
  TC_SPLIT_TRADE_AMOUNT: 'Trade Split Amt',
  TC_ACTION_ROLL: 'Roll',
  TC_LINKED_TRADE_ID: 'Linked Trade Id',
  TC_ACTION_PURGE_TRADE_DATA: 'Purge Trade Data',
  TC_ACTION_RESET_TEST_DATA: 'Reset Test Data',
  TC_ACTION_EOD_PURGE: 'EOD Purge',
  TC_ACTION_SET_CURRENT_TRADE_DATE: 'Set Current Trade Date',
  TC_ACTION_SET_CURRENT_TRADE_DATE_TO_PREVIOUS_BUSINESS_DAY: 'Previous Business Day',
  TC_ACTION_SKIP_HOLIDAYS: 'Skip Holidays',
  TC_ACTION_TRIGGER_FIRDS_REPORT: 'Trigger Firds Report',
  TC_ACTION_TRIGGER_BOND_NOTE_UPDATE: 'Bonds Note Update',
  TC_ACTION_TRIGGER_INCREMENT_IDS: 'Increment Ids',
  TC_ACTION_TRIGGER_OKTA_USERS_REPORT: 'Trigger Okta Report',
  TC_ACTION_TRIGGER_UPDATE_MORTGAGE_FACTORS: 'Update Mort Factors',
  TC_ACTION_TRIGGER_COLLATERAL_MIGRATION: 'Collateral Migration',
  TC_ACTION_TRIGGER_COLLATERAL_CLEAR_TRADE_DATE: 'Clear First Trade Date',
  TC_ACTION_TRIGGER_GENERATE_SCHEDULE_REPORT: 'Schedule Report',
  TC_ACTION_TRIGGER_REFINITIV_PRICE_REQUEST: 'Refinitiv Price Req',
  TC_ACTION_TRIGGER_REFINITIV_COLLATERAL_REQUEST: 'Retry Collateral load',
  TC_ACTION_TRIGGER_REFINITIV_RIC_CODE_REQUEST: 'Collateral Refresh',
  TC_ACTION_TRIGGER_REFINITIV_ISSUER_REFRESH_REQUEST: 'Issuer Org Refresh',
  TC_ACTION_TRIGGER_REFINITIV_NEW_FIELDS_REQUEST: 'Collateral New Fields',
  TC_ACTION_TRIGGER_REFINITIV_CORPS_REFRESH_REQUEST: 'Collateral Corps Refresh',
  TC_INFLIGHT: 'Inflight/Traded',

  // context menus
  TC_CONTEXT_MENU_PIN: 'Pin',
  TC_CONTEXT_MENU_UNPIN: 'Unpin',
  TC_CONTEXT_MENU_MOVE_DOWN: 'Move Down',
  TC_CONTEXT_MENU_MOVE_UP: 'Move Up',
  TC_CONTEXT_MENU_MOVE_TO_TOP: 'Move To Top',
  TC_CONTEXT_MENU_MOVE_TO_BOTTOM: 'Move To Bottom',

  // action tooltips
  SC_MAX_ORDERS_ACTIONS_TOOLTIP:
    'You have selected more than the maximum orders ({maxOrders}) that can be actioned together. Please reduce the number and try again.',
  SC_MAX_ORDERS_PREPARE_TOOLTIP:
    'Your selection of orders and counterparties will result in more than the max number of negotiations that can be processed at one time ({maxPrepare}). Please reduce the number and try again.',
  SC_MAX_COLLECTION_SIZE_TOOLTIP:
    'You are trying to create a collection with more than the maximum number of legs ({remainingLegs}/{maxLegs}), please reduce the number and try again.',
  SC_MAX_NAMED_COLLECTION_SIZE_TOOLTIP:
    'You are trying to create a collection [{collectionName}] with more than the maximum number of legs ({remainingLegs}/{maxLegs}), please reduce the number and try again.',

  // * Axe and trade condition renderer
  TC_AXED: '{isAxed, select, true {} false {Not } other {Not }}Axed',

  // lock
  SC_UNLOCKED: 'Unlocked',
  SC_LOCKED_TO: 'Locked to {user}',

  // otw timer
  SC_AS_RFQ: 'As RFQ',
  SC_LAST_LOOK: 'Last look',

  // delta
  SC_DELTA_DAYS: '{days, plural, =1 {{formattedDays} day} other {{formattedDays} days}}',

  // error messages
  SC_MISSING_MANDATORY: 'A value is required',
  SC_INVALID_VALUE: 'Value is invalid', // todo the server returns some more specific details
  SC_GENERIC_ERROR: 'Error',
  SC_INVALID_OTW: 'OTW duration is invalid',
  SC_SUBSCRIPTION_RESPONSE_ERROR:
    'Error returning results for subscription identifier: {subscriptionIdentifier} and entity type: {entityTypeEnum} - ({error})',
  SC_SUBSCRIPTION_RESPONSE_TOO_LARGE_ERROR:
    'Subscription result set too large for subscription identifier: {subscriptionIdentifier} and entity type: {entityTypeEnum}',

  // boolean values
  TC_TRUE: 'Yes',
  TC_FALSE: 'No',

  // Initiated screen views
  TC_GRID_DEFAULT: 'Default',
  TC_GRID_COUNTERPARTY: 'Counterparty',

  // Grid view screen
  SC_NOT_AVAILABLE_FOR_THIS_PROFILE: 'Not available for this profile',

  // Sector mapping screen
  TC_SECTOR_MAPPING_RULE_NAME: 'Rule Name',
  TC_SECTOR_MAPPING_DEBT_TYPE: 'Debt Type',
  TC_SECTOR_MAPPING_GOVERNMENT_BOND_TYPE: 'Government Bond Type',
  TC_SECTOR_MAPPING_NOT_GOVERNMENT_BOND_TYPE: 'Not Government Bond Type',
  TC_SECTOR_MAPPING_BASE_INDEX: 'Base Index is NULL',
  TC_SECTOR_MAPPING_HAS_CUSIP: 'Has CUSIP',
  TC_SECTOR_MAPPING_RULE_ID: 'Rule Id',
  TC_SECTOR_CURRENT_MAPPINGS: 'Current Mappings',
  TC_SECTOR_DRAFT_MAPPINGS: 'Draft Mappings',
  TC_SECTOR_EDIT_MAPPINGS: 'Edit Draft Mapping',
  TC_SECTOR_CREATE_MAPPINGS: 'Create Draft Mapping',
  TC_SECTOR_COMMIT_MAPPINGS: 'This will copy these draft mappings to the current mappings, are you sure you wish to continue',
  TC_SECTOR_DISCARD_MAPPINGS:
    'This will discard these draft mappings and replace them with the current mappings, are you sure you wish to continue',
  // Trade Condition
  SC_NONE: 'None',
  SC_ROLL: 'Roll',
  SC_UNWIND: 'Unwind',
  SC_SUB: 'Sub',

  // Repo Type
  TC_REPO_TYPE_BSB: 'BSB',
  TC_REPO_TYPE_CLASSIC: 'Classic',
  TC_REPO_TYPE_STOCK_BORROWING_LENDING: 'SBL',

  // Direction
  TC_BUY: 'Buy',
  TC_SELL: 'Sell',
  TC_REV_REPO: 'Rev Repo',
  TC_REPO: 'Repo',
  TC_BID: 'Bid',
  TC_OFFER: 'Offer',
  TC_BORROW: 'Borrow',
  TC_LEND: 'Lend',
  TC_MULTI: 'Multi',

  // Collection Type
  TC_ALL_OR_NOTHING: 'AON',
  TC_NON_CONTINGENT: 'Non Contingent',
  TC_SEND_INDIVIDUALLY: 'Standard',
  TC_SEND_INDIVIDUALLY_ABBR: 'STD',
  TC_ONE_CANCELS_OTHERS: 'OCO',
  TC_SMART_GROUPING: 'SG',
  TC_ALL_OR_NOTHING_COLLECTION: 'AON Collection',
  TC_ALL_OR_NOTHING_X: 'AONX',

  // Organisation Type
  SC_BUY_SIDE: 'Buy-side',
  SC_SELL_SIDE: 'Sell-side',

  // Collateral Type
  TC_COLLATERAL_TYPE_STANDARD: 'Standard',
  TC_COLLATERAL_TYPE_INDEX_LINKED: 'Index Linked',

  // Coupon Type
  TC_FIXED: 'Fixed',
  TC_FLOATING: 'Floating',

  // Coupon Frequency
  TC_ANNUAL: 'Annual',
  TC_SEMI_ANNUAL: 'Semi-Annual',
  TC_QUARTERLY: 'Quarterly',
  TC_MONTHLY: 'Monthly',

  // Trading Entity Type
  TC_STANDARD: 'Standard',
  TC_BLOCK: 'Block',
  TC_BOTH: 'Both',

  // Index Lag
  TC_INDEX_LAG_THREE_MONTHS: '3M',
  TC_INDEX_LAG_EIGHT_MONTHS: '8M',

  // other
  UC_NOT_APPLICABLE: 'N/A',

  SC_MULTIPLE: 'Multiple',
  TC_PRE_ASSIGNED: 'Pre-Assigned',

  // Derived data columns
  TC_COUNT: 'Count',

  // Repo Classification Type
  TC_REPO_CLASSIFICATION_FIXED: 'Fixed',
  TC_REPO_CLASSIFICATION_OPEN: 'Open',
  TC_REPO_CLASSIFICATION_OPEN_EVERGREEN: 'Open-Evergreen',

  // Currency type
  TC_CURRENCY_AUD: 'AUD',
  TC_CURRENCY_CAD: 'CAD',
  TC_CURRENCY_DKK: 'DKK',
  TC_CURRENCY_EUR: 'EUR',
  TC_CURRENCY_GBP: 'GBP',
  TC_CURRENCY_JPY: 'JPY',
  TC_CURRENCY_SEK: 'SEK',
  TC_CURRENCY_USD: 'USD',
  TC_CURRENCY_NZD: 'NZD',
  TC_CURRENCY_CHF: 'CHF',
  TC_CURRENCY_NOK: 'NOK',
  TC_CURRENCY_HUF: 'HUF',
  TC_CURRENCY_PLN: 'PLN',
  TC_CURRENCY_ZAR: 'ZAR',
  TC_CURRENCY_SGD: 'SGD',
  TC_CURRENCY_ARS: 'ARS',
  TC_CURRENCY_BRL: 'BRL',
  TC_CURRENCY_CLP: 'CLP',
  TC_CURRENCY_COP: 'COP',
  TC_CURRENCY_MXN: 'MXN',
  TC_CURRENCY_VEF: 'VEF',
  TC_CURRENCY_CZK: 'CZK',
  TC_CURRENCY_AED: 'AED',
  TC_CURRENCY_TRY: 'TRY',
  TC_CURRENCY_KRW: 'KRW',
  TC_CURRENCY_ILS: 'ILS',
  TC_CURRENCY_BGN: 'BGN',
  TC_CURRENCY_ISK: 'ISK',
  TC_CURRENCY_RON: 'RON',
  TC_CURRENCY_QAR: 'QAR',
  TC_CURRENCY_HKD: 'HKD',
  TC_CURRENCY_KWD: 'KWD',
  TC_CURRENCY_BHD: 'BHD',
  TC_CURRENCY_CNH: 'CNH',
  TC_CURRENCY_CNY: 'CNY',
  TC_CURRENCY_EGP: 'EGP',
  TC_CURRENCY_IDR: 'IDR',
  TC_CURRENCY_INR: 'INR',
  TC_CURRENCY_JOD: 'JOD',
  TC_CURRENCY_KZT: 'KZT',
  TC_CURRENCY_MAD: 'MAD',
  TC_CURRENCY_MYR: 'MYR',
  TC_CURRENCY_PEN: 'PEN',
  TC_CURRENCY_PHP: 'PHP',
  TC_CURRENCY_PYG: 'PYG',
  TC_CURRENCY_RUB: 'RUB',
  TC_CURRENCY_SAR: 'SAR',
  TC_CURRENCY_SDG: 'SDG',
  TC_CURRENCY_THB: 'THB',
  TC_CURRENCY_TND: 'TND',
  TC_CURRENCY_TWD: 'TWD',
  TC_CURRENCY_UAH: 'UAH',
  TC_CURRENCY_UYU: 'UYU',
  TC_CURRENCY_VND: 'VND',

  // Market
  TC_MARKET_EUROPE: 'Europe',
  TC_MARKET_US: 'US',

  // Mid trade event action
  TC_MTE_CLOSE: 'Close',
  TC_MTE_RESIZE: 'Resize',
  TC_MTE_REPRICE: 'Reprice',
  TC_MTE_ROLL: 'Roll',

  // RFQ Type
  TC_RFQ_TYPE_FIRM: 'Firm',
  TC_RFQ_TYPE_INDICATIVE: 'Indicative',

  //Callable type
  TC_CALLABLE_TYPE_BILATERAL: 'Bilateral',
  TC_CALLABLE_TYPE_UNILATERAL: 'Unilateral',

  //Notification preference type
  TC_USERS_SALES_COVER_ONLY: 'Only my Sales',

  // Ex dividend day convention
  TC_BUSINESS_DAYS: 'Business Days',
  TC_CALENDAR_DAYS: 'Calendar Days',

  // Haircut type
  TC_HAIRCUT_TYPE_HAIRCUT: 'Haircut',
  TC_HAIRCUT_TYPE_COLLATERAL: 'Collateral',

  // Haircut sign
  TC_ACTUAL_SELL_SIDE: 'Actual Sell Side',
  TC_DIRECTIONAL: 'Directional',
  TC_ABSOLUTE: 'Absolute',
  TC_NEGATIVE_REV_REPO: 'Negative Rev Repo',

  // Date picker
  SC_UNRECOGNISED_DATE_FORMAT: 'Unrecognisable date value',
  SC_DATE_NOT_ALLOWED: 'Selected date is not allowed',
  SC_DATE_MUST_BE_AFTER: 'Date must be on or after {date}',
  SC_DATE_MUST_BE_BEFORE: 'Date must be on or before {date}',

  // Page controls toolbar
  SC_PAGE_CONTROL_OF: 'of',
  SC_PAGE_CONTROL_PAGE: 'Page',

  // Multiple Notional
  TC_MULTIPLE_NOTIONAL_MULTIPLE: 'Multiple',

  // Start Time Zones
  TC_START_TIME_ZONE_AMSTERDAM: 'Amsterdam',
  TC_START_TIME_ZONE_LONDON: 'London',
  TC_START_TIME_ZONE_NEW_YORK: 'New York',
  TC_START_TIME_ZONE_TOKYO: 'Tokyo',

  // Trades Related Panel
  TC_REPO_RATE: 'Repo Rate',
  TC_REPO_INTEREST_START_DATE: 'Repo Int Start Date',
  TC_EVENT: 'Event',
  TC_ORIGINATING_EVENT: 'New Trade Event',
  TC_PREV_REPO_INTEREST_START_DATE: 'Prev Repo Int Start Date',
  TC_PREV_REPO_INTEREST_TO_DATE: 'Repo Int To Date',
  TC_PREV_REPO_INTEREST_RATE: 'Prev Repo Rate',
  TC_PREV_REPO_INTEREST_END_DATE: 'Prev Repo Int End Date',
  TC_PREV_REPO_INTEREST_IN_PERIOD: 'Repo Int In Period'
}

export default translations
